<template>
  <div class="adminAccountSidebarNew">
    <!-- {{this.groupList}} -->
    <div class="sidebar-list">
      <!-- 创建账号 -->
      <el-button type="button" icon="el-icon-add" @click="creatcount">{{ $t('account.createAccount') }}</el-button>
      <!-- 关联业主 -->
      <el-button class="relatedOwnerButton" type="button" icon="el-icon-link" @click="relatedOwner" v-if="this.$store.state.user.role == 2">{{
        $t('account.relatedOwner') }}</el-button>
      <div class="spliteline"></div>
      <!-- 搜索账号名称/手机号码 -->
      <!-- @keyup.enter.native="getAccountList(true)" -->
      <!-- v-model="search.usr" -->
      <!-- <el-input
        :placeholder="$t('account.placeholder')"
        prefix-icon="el-icon-search"
        v-model="search.groupname"
        style="width:206px;font-size:14px;"
        class="search-input"
        @keyup.enter.native="getOneGroup(true)"
      ></el-input>-->
      <ul class="tabBox">
        <li v-for="(item, index) in tabData" :key="item.name" :class="{ active: !(index - menuIndex) }"
          @click="tabActive(index)" :style="(index - menuIndex)?pointerEventsStyle:pointerEventsStyleNone">{{ item.name }}</li>
      </ul>
      <div v-show="menuIndex == 0" class="nameBox">
        <div v-clickoutside="closeSearchBox" style="margin-bottom:10px">
          <!-- 带下拉盒的实时搜索 -->
          <!-- @blur="searchAccountBox=false" -->
          <!-- class="sideSearchIpt" width:206px; -->
          <el-input :placeholder="$t('account.placeholder')" prefix-icon="el-icon-search" v-model="search.usr"
            style="font-size:14px;" class="search-input" @input="getSearchAccount"></el-input>
          <div class="inputCell">
            <div class="searchAccountBox" v-show="searchAccountBox" v-loading="loadingSearchAccountBox"
              element-loading-spinner="el-icon-loading">
              <div v-for="(item, index) in searchAccountList" :key="index">
                <span class="searchAccountCell" @click="enterAccount(item)">{{ item.usr }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 树形图=================== -->
        <div style="width: 100%;height: 550px;overflow: scroll;" class="treeBox">
          <el-tree lazy :props="defaultProps" element-loading-spinner="el-icon-loading" v-loading="loading"
            :load="loadNode" class="mytree" style="width:550px;" :data="treeData3" node-key="id" ref="tree"
            @node-drag-start="handleDragStart" @node-drag-enter="handleDragEnter" @node-drag-leave="handleDragLeave"
            @node-drag-over="handleDragOver" @node-drag-end="handleDragEnd" @current-change="clickNode"
            :expand-on-click-node="true" draggable :allow-drop="allowDrop" :allow-drag="allowDrag"
            :default-expanded-keys="expandArr">
            <span slot-scope="{ node, data }">
              <!-- 自定义树状一级的收展 -->
              <!-- @click="handleDrop" -->
              <i class="treeLevelOneHandle iconfont icon-a-mingchengxiaojiantoushouqi3" @click.stop="shrinkTreeNode"></i>
              <!-- <i class="iconfont " :class="data.iconOut"></i> -->
              <i class="iconfont" :class="data.icon"></i>
              <span>{{ node.label }}</span>
              <!-- 操作 -->
              <!-- <span class="operateBox">
                  阻止事件冒泡
                  <i class="operateOut iconfont" :class="data.iconOut" @click.stop="treeAddFun(data)"></i>
                  <i class="operateIn iconfont" :class="data.iconIn"></i>
                  <el-dropdown class="eb-dropdown" placement="bottom-start">
                    按钮
                    <i class="operateIn iconfont icon-a-mingchengshenglvehao"></i>
                    下拉
                    <el-dropdown-menu 
                      slot="dropdown" 
                      class="mytree-dropdown-list eb-tree-dropdown-list"
                    >
                      <el-dropdown-item>
                        <i class="iconfont icon-fuzhi-3" @click="treeCopyFun(data)"></i>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <i class="iconfont icon-delete" @click="treeDelFun(data)"></i>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
              </span>-->
            </span>
          </el-tree>
        </div>
      </div>
      <div v-show="menuIndex == 1" style="height:570px">
        <!-- 当前共X个用户 -->
        <!-- <div class="viewbox">
          <span class="totalNum">
            {{`${$t('account.currentTotal')} ${accountTotal.accountTotal} ${$t('account.accounts')}`}}
          </span>
        </div>-->
        <div class="addFenzu">
          <span>{{ $t('account.allGroup') }}</span>
          <i :title="$t('group.Create_groups')" @click="creatgroup" class="iconfont icon-a-mingchengfangxingjia"></i>
        </div>
        <el-table v-show="true" :data="groupListClick" stripe border height="100%" :row-style="{ height: 0 }"
          :cell-style="{ padding: 0 }" :header-cell-style="{ background: '#F2F5F7', color: '#606266' }"
          :show-header="false" style="overflow-y:auto;" class="proDeviceList sidebartableloding"
          element-loading-spinner="el-icon-loading" v-loading="loadingGroupAccount">
          <el-table-column prop="groupName" label>
            <template slot-scope="props">
              <span class="group-box">
                <span class="group-label" :class="{ 'activeGroup': props.row.id == currentGroupId }">
                  <i v-if="!props.row.id" class="iconfont icon-a-mingchengyonghushuxingsanren3"
                    style="margin-right:10px;"></i>
                  <!-- 其它 -->
                  <i v-if="props.row.id" class="iconfont icon-a-mingchengyonghushuxingsanren3"
                    style="margin-right:10px;"></i>
                  <span class="label-name" @click.stop="getClickGroupList(props.row, currentGroupId)">{{
                    `${props.row.groupName}
                    `}}</span>
                  <span v-if="!props.row.id" class="label-num"></span>
                </span>
                <span class="group-operate" @click.stop>
                  <span class="operate-box">
                    <!-- 编辑分组 -->
                    <i :title="$t('account.Edit')" class="ico ico-edit" @click.stop="editGroup(props.row)"></i>
                    <!-- 删除分组 -->
                    <!-- v-if="item.pid != '253964'" -->
                    <i :title="$t('account.Delete')" style="margin-left:10px;" class="ico ico-del"
                      @click.stop="delGroup(props.row)"></i>
                  </span>
                </span>
              </span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 该盒占位修复侧栏列表滚动问题 -->
        <div style="width:100%;height:56px;"></div>
      </div>
    </div>
    <!-- 创建新账号 -->
    <!-- v-if="showCreatnewcountDialog" -->
    <device-dialog :title="$t('account.createAccount')" :visible.sync="showCreatnewcountDialog" width="550px"
      :class="{ 'showDialog': showCreatnewcountDialog, 'hideDialog': !showCreatnewcountDialog }" noFooter>
      <el-form ref="creatForm" :model="form" class="chuangjian grid" slot="content" :rules="creatRules">
        <el-form-item :label="$t('account.role1')" prop="role">
          <el-select v-model="form.role" :placeholder="$t('account.selectUserType')"
            popper-class="select-search-recharge" clearable>
            <el-option :label="$t('account.powerStationOwner')" value="0"></el-option>
            <el-option :label="$t('account.distributor')" value="2"></el-option>
            <el-option v-if="$store.state.user.riyueyuanPermissionMark&&$store.state.user.role==1" :label="this.$t('account.riyueyuan_SonAdmin')" value="100"></el-option>
            <!-- <el-option v-if="$store.state.user.riyueyuanPermissionMark&&$store.state.user.role==1" :label="this.$t('account.riyueyuan_lineSonAdmin')" value="200"></el-option> -->
          </el-select>
        </el-form-item>
        <!-- 账号分组 -->
        <el-form-item :label="$t('account.accountGroup')" prop="id">
          <el-select v-model="form.id" placeholder popper-class="select-search-recharge">
            <el-option v-for="item in groupList" :key="item.id" :value="item.id" :label="item.groupName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('account.accountName1')" prop="name">
          <el-input v-model.trim="form.name" clearable :placeholder="$t('account.accountName')" @clear="Bytecheck"
            @keyup.native="UserByte" @keyup.enter.native="$refs.creatqname.focus()"></el-input>
          <div class="inputlo">
            <div :class="isError ? 'input_spans' : 'sucess'" v-show="!Byte">
              <span>{{ usrtip }}</span>
            </div>
            <div class="input_span" v-show="Byte">
              <span style="font-size: 12px;font-weight: bold;">{{ $t('signup.Byte_1') }}</span>
              <span style="margin-left:2px;font-size:12px;font-weight:bold;color:#f00;">{{ Bytes }}</span>
              <span style="font-size: 12px;font-weight: bold;margin-left: 2px;">{{ $t('signup.Byte_2') }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.nickname1')" prop="qname">
          <el-input v-model.trim="form.qname" :placeholder="$t('account.nickname')" clearable ref="creatqname"
            @keyup.enter.native="$refs.creatmobile.focus()"></el-input>
        </el-form-item>
        <el-form-item :label="$t('account.mobile1')" prop="mobile">
          <el-input clearable type="text" v-model.trim="form.mobile" ref="creatmobile"
          @keyup.enter.native="$refs.createmail.focus()">
          </el-input>
          <div class="inputlo">
            <div :class="phoneError ? 'phone_span' : 'sucess'">
              <span>{{ phonetip }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.email1')" prop="email">
          <el-input clearable v-model.trim="form.email" auto-complete="off" ref="createmail"
          @keyup.enter.native="$refs.creatpwd.focus()">
          </el-input>
          <div class="inputlo">
            <div :class="emailError ? 'email_span' : 'sucess'">
              <span>{{ emailtip }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.password1')" prop="pwd">
          <el-input v-model.trim="form.pwd" :placeholder="$t('account.password')" clearable type="text" class="password"
            ref="creatpwd" @clear="pwdcheck" @input.native="Passwordlevel"
            @keyup.enter.native="$refs.creatconfPwd.focus()"></el-input>
          <div class="inputlo">
            <div :class="passpwdError ? 'pwd_span' : 'sucess'" v-show="!strength">
              <span>{{ pwdtip }}</span>
            </div>
            <div class="input_span" v-show="strength">
              <span style="font-size: 12px;font-weight: bold;">{{ $t('signup.qiangdu') }}</span>
              <span class="juxing" ref="Passwordlevel"></span>
              <span style="font-size: 12px;font-weight: bold;margin-left: 5px;">{{ count }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.confirmpassword1')" prop="confPwd">
          <el-input v-model.trim="form.confPwd" :placeholder="$t('account.confirmpassword')" clearable type="text"
            class="password" ref="creatconfPwd" @keyup.enter.native="$refs.createmail.focus()"></el-input>
          <div class="inputlo">
            <div :class="confpwdError ? 'confpwd_span' : 'sucess'">
              <span>{{ confpwdtip }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.Related_roles')" v-if="this.$store.state.user.role ==1&&(form.role ==2||form.role ==100||form.role ==200)" prop="roleId">
          <el-select v-model="form.roleId" :placeholder="$t('account.Ple_role1')" popper-class="select-search-recharge" clearable>
            <el-option v-for="(item, index) in DistRoleList" :key="index" :value="item.roleId" :label="item.roleName"></el-option>
          </el-select>
        </el-form-item>
        <div  v-if="this.$store.state.user.role ==1&&form.role ==2" style="max-width: 150px;word-break: break-all;">{{ $t('account.dataogger_swith') }}:</div>
        <div style="position: relative;margin-left: 20px;display: flex;align-items: center;"  v-if="this.$store.state.user.role ==1&&form.role ==2">
            <i class="el-icon-check" v-if="dataoggerSwithControl" 
            style="position: absolute;z-index: 1;left: 12px;top: 50%;margin-top: -7px;"></i>
             <el-switch class="eb-switch" v-model="dataoggerSwithControl" :width="50">
             </el-switch>
          <span class="help-label">{{ $t('account.dataogger_swithTip') }}</span>
        </div>
        <div></div>
        <div style="text-align:right;">
          <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
          <button type="button" class="btn btn-dark" @click="creatnewcount">{{ $t('account.submit') }}</button>
        </div>
      </el-form>
    </device-dialog>
    <!-- 关联业主 -->
    <device-dialog :title="$t('account.relatedOwner')" :visible.sync="showRelatedOwnerDialog" width="550px"
      :close-on-click-modal="false"
      :class="{ 'showDialog': showRelatedOwnerDialog, 'hideDialog': !showRelatedOwnerDialog }" noFooter>
      <el-form :model="relationForm" ref="relationFormRef"  class="grid" slot="content">
        <el-form-item prop="usr" :label="$t('account.accountName')"
        :rules="[{ required: true, message: $t('account.accountName2'), trigger: ['blur','change'] },]">
          <el-input v-model.trim="relationForm.usr" clearable :placeholder="$t('account.accountName')"></el-input>
        </el-form-item>

        <div></div>
        <div style="text-align:right;">
          <button style="margin-right:10px" class="btn btn-light" @click="showRelatedOwnerDialog = false">{{ $t('account.cancel')
          }}</button>
          <button type="button" class="btn btn-dark" @click="relatedOwner1">{{ $t('account.confirm') }}</button>
        </div>
      </el-form>
    </device-dialog>
    <!-- 创建新账号结果提示(成功) -->
    <!-- v-if="creatAccountSucVisible" -->
    <device-dialog :title="$t('account.createAccount')" :visible.sync="creatAccountSucVisible"
      :class="{ 'showDialog': creatAccountSucVisible, 'hideDialog': !creatAccountSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('account.createSuc') }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="creatAccountSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 创建新账号结果提示(失败) -->
    <!-- v-if="creatAccountFailVisible" -->
    <device-dialog :title="$t('account.createAccount')" :visible.sync="creatAccountFailVisible"
      :class="{ 'showDialog': creatAccountFailVisible, 'hideDialog': !creatAccountFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="creatAccountFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>

    <!-- 创建分组弹窗 -->
    <!-- v-if="showCreatgroupDialog" -->
    <device-dialog :title="$t('group.Create_groups')" :visible.sync="showCreatgroupDialog" :width="'450px'"
      :class="{ 'showDialog': showCreatgroupDialog, 'hideDialog': !showCreatgroupDialog }" noFooter>
      <el-form ref="form" :model="group" label-position="right" slot="content" :rules="groupRules"
        class="grid">
        <el-form-item :label="$t('group.Group_name1')" prop="groupName">
          <el-input type="text" v-model.trim="group.groupName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('group.note1')" prop="desc">
          <el-input type="text" v-model.trim="group.desc" autocomplete="off"></el-input>
        </el-form-item>
        <!-- Grid占位 -->
        <div></div>
        <div style="text-align:right;">
          <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
          <button type="button" class="btn btn-dark" @click="creatnewgroup">{{ $t('account.submit') }}</button>
        </div>
      </el-form>
    </device-dialog>
    <!-- 创建分组结果提示(成功) -->
    <!-- v-if="creatGroupSucVisible" -->
    <device-dialog :title="$t('group.Create_groups')" :visible.sync="creatGroupSucVisible"
      :class="{ 'showDialog': creatGroupSucVisible, 'hideDialog': !creatGroupSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('group.creatsuc') }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="creatGroupSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 创建分组结果提示(失败) -->
    <!-- v-if="creatGroupFailVisible" -->
    <device-dialog :title="$t('group.Create_groups')" :visible.sync="creatGroupFailVisible"
      :class="{ 'showDialog': creatGroupFailVisible, 'hideDialog': !creatGroupFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="creatGroupFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>

    <!--编辑分组弹窗 -->
    <!-- v-if="showEditDialog" -->
    <device-dialog :title="$t('group.Edit_groups')" :visible.sync="showEditDialog" :width="'450px'"
      :class="{ 'showDialog': showEditDialog, 'hideDialog': !showEditDialog }" noFooter>
      <el-form ref="editGroupsForm" :model="groupsDatas" label-position="right" slot="content" :rules="groupRules"
        class="grid">
        <el-form-item :label="$t('group.Group_name1')" prop="groupName">
          <el-input type="text" v-model.trim="groupsDatas.groupName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('group.note1')" prop="desc">
          <el-input type="text" v-model.trim="groupsDatas.desc" autocomplete="off"></el-input>
        </el-form-item>

        <!-- Grid占位 -->
        <div></div>
        <div style="text-align:right;">
          <!-- <button class="button-hollow" @click="showEditDialog = false">{{$t('group.cancel')}}</button> -->
          <button type="button" class="btn btn-dark" @click="submitEditGroup">{{ $t('group.confirm') }}</button>
        </div>
      </el-form>
    </device-dialog>
    <!-- 编辑分组结果提示(成功) -->
    <!-- v-if="editGroupSucVisible" -->
    <device-dialog :title="$t('group.Edit_groups')" :visible.sync="editGroupSucVisible"
      :class="{ 'showDialog': editGroupSucVisible, 'hideDialog': !editGroupSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('group.editsuc') }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="editGroupSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 编辑分组结果提示(失败) -->
    <!-- v-if="editGroupFailVisible" -->
    <device-dialog :title="$t('group.Edit_groups')" :visible.sync="editGroupFailVisible"
      :class="{ 'showDialog': editGroupFailVisible, 'hideDialog': !editGroupFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="editGroupFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>

    <!-- 删除分组弹窗：去掉弹框的heard不加title=""和footer noFooter -->
    <!-- v-if="showDeleteDialog" -->
    <device-dialog :title="$t('group.deletegroup')" :visible.sync="showDeleteDialog" :width="'450px'"
      :class="{ 'showDialog': showDeleteDialog, 'hideDialog': !showDeleteDialog }" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <span class="contentdelete" style="width:100%;text-align:left;">{{ $t('group.deleteConfirm') }}</span>
        </div>
        <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;">{{ $t('account.notRecovered') }}</span>
        </div>
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" style="margin-right:10px;" @click="submitDelGroup">{{
            $t('group.confirm') }}</button>
          <button type="button" class="btn btn-light" @click="showDeleteDialog = false;">{{ $t('group.cancel') }}</button>
        </div>
      </div>
    </device-dialog>
    <!-- 删除分组结果提示(成功) -->
    <!-- v-if="delGroupSucVisible" -->
    <device-dialog :title="$t('group.deletegroup')" :visible.sync="delGroupSucVisible"
      :class="{ 'showDialog': delGroupSucVisible, 'hideDialog': !delGroupSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('group.deletesuc') }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="delGroupSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 删除分组结果提示(失败) -->
    <!-- v-if="delGroupFailVisible" -->
    <device-dialog :title="$t('group.deletegroup')" :visible.sync="delGroupFailVisible"
      :class="{ 'showDialog': delGroupFailVisible, 'hideDialog': !delGroupFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="delGroupFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>
  </div>
</template>
<script>
import deviceDialog from "@/components/dialognew";
// import { i18n } from "@/i18n";
import encryption from "@/assets/js/encryption";
import { mapGetters } from "vuex";
import Vue from "vue";
export default {
  components: {
    deviceDialog
  },
  data () {
    // 定义数据规则
    var validateusr = (rule, value, callback) => {
      var ref = /^\S{1,31}[a-zA-Z0-9_一-龥]$/;
      if (!value) {
        callback(new Error(""));
        this.usrtip = this.$t("message.uname_is_required");
        this.isError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.usrtip = this.$t("signup.usrformat");
        this.isError = true;
      } else {
        callback();
      }
    };
    var validatepwd = (rule, value, callback) => {
      var ref = /^[\w]{6,32}$/;
      if (!value) {
        callback(new Error(""));
        this.pwdtip = this.$t("message.pwd_is_required");
        this.passpwdError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.pwdtip = this.$t("signup.pwdformat");
        this.passpwdError = true;
      } else {
        callback();
      }
    };
    //新建账号的密码确认
    var validateconfPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdAgain");
        this.confpwdError = true;
      } else if (value !== this.form.pwd) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdNotsame");
        this.confpwdError = true;
      } else {
        this.confpwdtip = "";
        callback();
      }
    };
    var validateemail = (rule, value, callback) => {
      var ref = /^(?=\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$).{0,64}$/;
      // if (!value) {
      //   callback(new Error(""));
      //   this.emailtip = this.$t("message.email_is_required");
      //   this.emailError = true;
      // } else 
      if (value&&!ref.test(value)) {
        callback(new Error(""));
        this.emailtip = this.$t("message.email_info");
        this.emailError = true;
      } else {
        this.emailtip = "";
        callback();
      }
    };
    var validatephone = (rule, value, callback) => {
      var ref = /^\d{6,32}$/;
      // if (!value) {
      //   callback(new Error(""));
      //   this.phonetip = this.$t("message.mobile_is_required");
      //   this.phoneError = true;
      // } else 
      if (value&&!ref.test(value)) {
        callback(new Error(""));
        this.phonetip = this.$t("signup.mobileformat");
        this.phoneError = true;
      } else {
        this.phonetip = " ";
        callback();
      }
    };
    return {
      // 判断是否有权限，之前的经销商不存在权限
      disPermissionsLogo:sessionStorage.getItem("disPermissionsLogo")?JSON.parse(sessionStorage.getItem("disPermissionsLogo")):false,
      // 页面权限集合
      btnList: sessionStorage.getItem("buttonArr")?JSON.parse(sessionStorage.getItem("buttonArr")):[],
      DistRoleList:[],
      // 树形控件==================
      // 默认展开节点
      dataoggerSwithControl: true,
      expandArr: [100],
      defaultProps: {
        children: "children",
        label: "label",
        isLeaf: "leaf"
      },
      // =========================
      // 默认全部收起
      treeStatus: false,
      // =========================
      // 筛选条件
      search: {
        role: null,
        active: null,
        enable: null,
        groupid: null,
        // 分组名称
        groupname: null,
        usr: null
      },
      searchOptions: {
        activeStatus: {
          true: {
            label: this.$t("statistic.active"),
            class: "active"
          },
          false: {
            label: this.$t("statistic.inactive"),
            class: "inactive"
          }
        }, // 活跃状态
        accountStatus: {
          true: {
            label: this.$t("account.enable"),
            class: "active"
          },
          false: {
            label: this.$t("account.disable"),
            class: "inactive"
          }
        } // 用户状态
      },
      accountList: [],
      //分页数据
      pagination: {
        currentPage: 1,
        pagesize: 15,
        total: 0
      },
      // 操作返回提示(错误时)
      dataloggerTipMsg: "",
      // 侧边栏加载
      loadingGroupAccount: false,
      // 当前点中设备
      devCurrentSn: "",
      // 分组
      groupList: [],
      // 当前用户总数
      totalAccounts: 0,
      // 创建新帐号
      form: {
        mobile: "",
        qname: "",
        name: "",
        email: "",
        role: "0",
        pwd: "",
        confPwd: "",
        // 账号分组
        group: [],
        id: "",
        roleId: "",
      },
      // 创建新帐号数据规则
      creatRules: {
        // 增 role和group
        role: [{ required: true, trigger: "blur" }],
        name: [{ required: true, validator: validateusr, trigger: "change" }],
        pwd: [{ required: true, validator: validatepwd, trigger: "change" }],
        confPwd: [
          { required: true, validator: validateconfPwd, trigger: "change" }
        ],
        email: [
          {validator: validateemail, trigger: "change" }
        ],
        mobile: [
          {validator: validatephone, trigger: "change" }
        ]
      },
      //默认不显示无数据
      loading: false,
      group: {
        groupName: "",
        desc: ""
      },
      groupsDatas: {
        groupName: "",
        desc: "",
        id: ""
      },
      groupRules: {
        groupName: [
          {
            required: true,
            message: this.$t("group.entername"),
            trigger: "blur"
          }
        ]
      },
      params: "",
      // 新建账号所需字段
      confpwdError: false,
      isError: false,
      emailError: false,
      passpwdError: false,
      phoneError: false,
      Bytes: "",
      count: "",
      Byte: false,
      usrtip: "",
      pwdtip: "",
      emailtip: "",
      phonetip: "",
      confpwdtip: "",
      strength: false,
      // 操作返回提示
      deviceTipMsg: "",
      // 侧栏编辑分组弹窗
      showEditDialog: false,
      // 编辑分组成功提示弹窗
      editGroupSucVisible: false,
      // 编辑分组失败提示弹窗
      editGroupFailVisible: false,
      // 侧栏删除分组弹窗
      showDeleteDialog: false,
      // 删除分组成功提示弹窗
      delGroupSucVisible: false,
      // 删除分组失败提示弹窗
      delGroupFailVisible: false,
      // 侧栏创建分组弹窗
      showCreatgroupDialog: false,
      // 创建分组成功提示弹窗
      creatGroupSucVisible: false,
      // 创建分组失败提示弹窗
      creatGroupFailVisible: false,
      // 侧栏创建账号弹窗
      showCreatnewcountDialog: false,
      // 创建账号成功提示弹窗
      creatAccountSucVisible: false,
      // 创建账号失败提示弹窗
      creatAccountFailVisible: false,
      //关联业主弹窗
      showRelatedOwnerDialog: false,
      //关联业主
      relationForm: {
        usr: ""
      },
      // 当前选中分组高亮
      // currentGroupId: '',
      currentGroupId: "",
      // 点击分组列表
      groupListClick: [],
      // 实时搜索账户下拉盒
      searchAccountBox: false,
      // 实时搜索账户下列表
      searchAccountList: [],
      // 实时搜索账户下列表加载态
      loadingSearchAccountBox: false,
      //账号uid
      AccountUid: "",
      //树形渲染数据
      treeData3: [
        {
          id: 100,
          label: this.$t("account.allAccount"),
          // 一级图标
          icon: "icon-a-mingchengyonghushuxingsanren1",
          iconOut: "icon-a-mingchengxiaojiantouyou1",
          uid: ""
        }
      ],
      //左侧切换栏数据
      tabData: [
        {
          name: this.$t("account.userAccount")
        },
        {
          name: this.$t("account.groupAccount")
        }
      ],
      treeGroupData: {
        uid: "",
        pid: ""
      },
      //用户与分组切换
      menuIndex: 0,
      groupIdClick1: "",
      groupNameClick1: ""
    };
  },
  computed: {
    // [点击分组ID/保存账户总数]
    ...mapGetters({
      groupIdClick: "getGroupIdClick",
      accountTotal: "getAccountTotal",
      accountInfo: "getAccountInfo",
      groupIsShow: "getGroupIsShow"
    }),
    pointerEventsStyle() {
      // 根据条件返回样式对象
      return {
        pointerEvents: this.$store.state.event.sidebartabUsrGroup ? 'none' : 'auto',
        opacity: this.$store.state.event.sidebartabUsrGroup ? '0.5' : '1',
      };
    },
    pointerEventsStyleNone() {
      // 根据条件返回样式对象
      return {
        pointerEvents: 'none',
        opacity: '1',
      };
    }
  },
  watch: {
    // 响应更新电站列表事件(账号列表)
    "$store.state.event.updateAccountList" (val) {
      if (val) {
        this.getData();
        this.$store.state.event.updateAccountList = false;
      }
    },
    // 左侧树形控件
    "$store.state.event.sidebarmodeTree" (val) {
      if (val) {
        this.getQuerySubAccountTree();
        this.$store.state.event.sidebarmodeTree = false;
      }
    },
    // [点击分组ID]
    groupIdClick: {
      handler (val) {
        this.$store.commit("saveGroupIdClick", {
          groupIdClick: val.groupIdClick,
          groupNameClick: val.groupNameClick,
        });
        this.currentGroupId = val.groupIdClick;
        // 请求该分组的用户列表
        this.search.groupid = val.groupIdClick;
        // this.getAccountList();
      },
      deep: true
    }
  },
  created () {
    // 获取经销商编码（创建经销商账号时有用）
    this.getVcode();
    // 获取权限角色，厂家创建经销商时
    this.getDistRoleList();
    // 当前分组ID
    this.currentGroupId = this.groupIdClick.groupIdClick;
    this.$store.state.event.sidebartabUsrGroup = true;
  },
  mounted () {
    // ....................................
    // 获取[一级菜单ID集合]
    let treeDataOrigin = this.treeData2;
    let treeDataLevel1Ids = [];

    treeDataOrigin &&
      treeDataOrigin.forEach(item => {
        treeDataLevel1Ids.push(item.id);
      });
    this.expandArr = treeDataLevel1Ids;
    // ....................................
  },
  beforeDestroy(){
    this.$store.commit("saveGroupIdClick", {
      groupIdClick: "",
      groupNameClick: ""
    });
    this.$store.commit("saveGroupIsShow", 0);
  },
  methods: {
    loadNode (node, resolve) {
      if (node.level <= 1) {
        this.$request
          .get("querySubAccountTree", { uid: this.AccountUid })
          .then(res => {
            if (res.err == 0) {
              let arr = [];
              res.dat.tree.forEach((item, index) => {
                if (item.rid==1||item.rid==2) {
                item.icon = "icon-a-mingchengyonghushuxingdiannao1";
                item.label =item.rid==1?
                  (item.usr + "-" + this.$t('account.riyueyuan_SonAdmin')):(item.usr + "-" + this.$t('account.riyueyuan_lineSonAdmin'));
                arr.push(item);
                }else if (item.role == 2) {
                  // code=index
                  // item.iconOut="icon-a-mingchengxiaojiantouyou1"
                  item.icon = "icon-a-mingchengyonghushuxingdiannao1";
                  item.label =
                    item.usr + "-" + this.$filter.roleNew(item.role).name;
                  arr.push(item);
                } else {
                  item.icon = "icon-a-mingchengyonghushuxingtianjia1";
                  item.label =
                    item.usr + "-" + this.$filter.roleNew(item.role).name;
                  item.leaf = true;
                  arr.push(item);
                }
              });
              if (node.level === 1) {
                return resolve(arr);
              }
            } else {
              return resolve([]);
            }
          });
      } else {
        if (node.data.role == 2) {
          this.$request
            .get("querySubAccountTree", { uid: node.data.uid })
            .then(res => {
              if (res.err == 0) {
                let arr = [];
                res.dat.tree.forEach((item, index) => {
                  if (item.rid==1||item.rid==2) {
                     item.icon = "icon-a-mingchengyonghushuxingdiannao1";
                     item.label =item.rid==1?
                       (item.usr + "-" + this.$t('account.riyueyuan_SonAdmin')):(item.usr + "-" + this.$t('account.riyueyuan_lineSonAdmin'));
                       arr.push(item);
                       item.children = [{}];
                   }else if (item.role == 2) {
                    item.icon = "icon-a-mingchengyonghushuxingdiannao1";
                    item.label =
                      item.usr + "-" + this.$filter.roleNew(item.role).name;
                    arr.push(item);
                    item.children = [{}];
                  } else {
                    item.icon = "icon-a-mingchengyonghushuxingtianjia1";
                    (item.label =
                      item.usr + "-" + this.$filter.roleNew(item.role).name),
                      (item.leaf = true);
                    arr.push(item);
                  }
                });
                if (node.level > 1) return resolve(arr);
              } else {
                return resolve([]);
              }
            });
        } else {
          return resolve([]);
        }
      }
    },
    //拖拽修改用户层级
    getWebTransferAccountToDist () {
      let param = {
        pid: this.treeGroupData.pid,
        uid: this.treeGroupData.uid
      };
      this.$request.get("webTransferAccountToDist", param).then(res => { });
    },
    // tabActiveClick(index) {
    //   // 节流函数
    //   this.tabActive = this.$tool._throttle(this.tabActive, 500);
    //   this.tabActive(index);
    // },
    //用户与分组切换
    tabActive (index) {
      this.menuIndex = index;
      Object.assign(this.$data.search,this.$options.data.call(this).search)
      if (this.menuIndex == 0) {
        this.$store.state.event.sidebartabUsrGroup = true;
        this.$emit("noticeDeviceBox", true);
        if(this.$store.state.user.groupIdClick){
          this.$store.commit("saveGroupIdClick", {
            groupIdClick: "",
            groupNameClick: ""
          });
        }else{
          this.$store.state.event.sidebartabUsrGroup = false;
        }
        this.$store.commit("saveGroupIsShow", 0);
      }
      if (this.menuIndex == 1) {
        this.$store.state.event.sidebartabUsrGroup = true;
        this.getData();
        this.$emit("noticeDeviceBox", true);
        this.$store.commit("saveGroupIsShow", 1);
      }
    },
    //树形数据获取
    getQuerySubAccountTree () {
      this.loading = true;
      this.$request
        .get("querySubAccountTree", { uid: this.AccountUid })
        .then(res => {
          if (res.err == 0) {
            let arr = [];
            res.dat.tree.forEach((item, index) => {
              if (item.rid==1||item.rid==2) {
                item.icon = "icon-a-mingchengyonghushuxingdiannao1";
                item.label =item.rid==1?
                  (item.usr + "-" + this.$t('account.riyueyuan_SonAdmin')):(item.usr + "-" + this.$t('account.riyueyuan_lineSonAdmin'));
                item.children = [{}];
                arr.push(item);
              }else if(item.role == 2){
                item.icon = "icon-a-mingchengyonghushuxingdiannao1";
                item.label =
                  item.usr + "-" + this.$filter.roleNew(item.role).name;
                item.children = [{}];
                arr.push(item);
              } else {
                // item.iconOut="icon-a-mingchengxiaojiantouyou1"
                item.icon = "icon-a-mingchengyonghushuxingtianjia1";
                (item.label =
                  item.usr + "-" + this.$filter.roleNew(item.role).name),
                  arr.push(item);
              }
            });
            this.treeData3=[
              {
                id: 100,
                label: this.$t("account.allAccount"),
                // 一级图标
                icon: "icon-a-mingchengyonghushuxingsanren1",
                iconOut: "icon-a-mingchengxiaojiantouyou1",
                uid: ""
              }
            ]
            Vue.set(this.treeData3[0], "children", arr);
          }
        });
      this.loading = false;
    },
    // ==============================
    // 收起全部并展开二级功能
    // ==============================
    shrinkTreeNode (item) {
      this.closeTreeNodeAll(this.$refs.tree.store.root);
      this.$emit("noticeDeviceBox", true);
    },
    // 改变节点的状态（收起全部）
    closeTreeNodeAll (node) {
      // console.log("node", node);

      if (node.level == 0 || node.level == 1) {
        // console.log("111");
        node.expanded = true;
        // ..................
        node.check = false;
        node.checked = false;
        node.isCurrent = false;
        // ..................
      } else {
        // console.log("222");
        node.expanded = false;
        // ..................
        node.check = false;
        node.checked = false;
        node.isCurrent = false;
        // ..................
      }
      for (let i = 0; i < node.childNodes.length; i++) {
        // 改变节点的自身expanded状态
        node.childNodes[i].expanded = false;
        // ................................
        node.childNodes[i].check = false;
        node.childNodes[i].checked = false;
        node.childNodes[i].isCurrent = false;
        // ................................
        // 看看他孩子的长度，有的话就调用自己往下找
        if (node.childNodes[i].childNodes.length > 0) {
          this.closeTreeNodeAll(node.childNodes[i]);
        }
      }
    },
    // ==============================
    // 操作
    // ==============================
    // treeAddFun(val){
    //   this.$message.success(val.label+" =》添加操作");
    // },
    // treeCopyFun(val){
    //   this.$message.success(val.label+" =》复制操作");
    // },
    // treeDelFun(val){
    //   this.$message.success(val.label+" =》删除操作");
    // },
    // ==============================
    // 树形控件-自主收展
    // ==============================
    handleNodeClick (data, node) {
      let param = {
        usr: data.usr,
        uid: data.uid,
        page: 0,
        pagesize: 500,
        devtype: 2304
      };
      this.$request.get("webQueryUsrEs", param).then(res => {
        res.dat.account.forEach((item, index) => {
          if (data.usr === item.usr) {
            item.role = this.$filter.role(item.role).name;
            let arr = item;
            this.$store.commit("saveAccountInfo", {
              collectorsNew: arr.collectors || "0", //
              devicesNew: arr.devices || "0", //
              avatarNew: arr.avatar, // 用户头像[重命名][缺]
              qnameNew: arr.qname, // 用户昵称
              usrNew: arr.usr || "--", // 账号名称
              enableNew: arr.enable || "--", // 是否禁用
              activeNew: arr.active || "--", // 活跃度
              roleNew: arr.role || "--", // 用户角色[重命名]
              // role: arr.role || '--', // 用户角色[重命名]
              mobileNew: arr.mobile || "--", // 电话
              emailNew: arr.email || "--", // 邮箱
              groupNew: arr.group || "--", // 分组
              createTimeNew: arr.gts || "--", // 创建时间
              lastLoginTsNew: arr.lastLoginTs || "--", // 最后登录时间
              sourceNew: arr.source || "--", // 用于判断是否储能用户
              uidNew: arr.uid || "--", //
              addCollectorPermissions: arr.addCollectorPermissions==false?false:true,  //是否有新增数采器权限
              rolePermissionId: arr.roleId, //厂家创建经销商账号选择的角色权限ID
              riyueyuanUserTypeRid: arr.rid //日月元新增用户类型标识
            });
          }
        });
      });
      if (data.role == 2) {
        this.$request
          .get("querySubAccountTree", { uid: data.uid })
          .then(res => {
            if (res.err == 0) {
              let arr = [];
              res.dat.tree.forEach((item, index) => {
                if (item.rid==1||item.rid==2) {
                  item.icon = "icon-a-mingchengyonghushuxingdiannao1";
                  item.label =item.rid==1?
                    (item.usr + "-" + this.$t('account.riyueyuan_SonAdmin')):(item.usr + "-" + this.$t('account.riyueyuan_lineSonAdmin')),
                  arr.push(item);
                }else if (item.role == 2) {
                  item.icon = "icon-a-mingchengyonghushuxingdiannao1";
                  (item.label =
                    item.usr + "-" + this.$filter.roleNew(item.role).name),
                    arr.push(item);
                } else {
                  item.icon = "icon-a-mingchengyonghushuxingtianjia1";
                  (item.label =
                    item.usr + "-" + this.$filter.roleNew(item.role).name),
                    arr.push(item);
                }
              });
              Vue.set(data, "children", arr);
            }
          });
      }
      this.enterAccount(data.uid);
    },
    //================
    //点击获取数据
    clickNode (data, node) {
      let param = {
        usr: data.usr,
        uid: data.uid,
        page: 0,
        pagesize: 500,
        devtype: 2304
      };
      if (param.usr) {
        this.$request.get("webQueryUsrEs", param).then(res => {
          let arr = {};
          res.dat.account.forEach((item, index) => {
            if (data.usr == item.usr) {
              item.role = this.$filter.role(item.role).name;
              arr = item;
              console.log(arr,"arr")
              this.$store.commit("saveAccountInfo", {
                collectorsNew: arr.collectors || "0", //
                devicesNew: arr.devices || "0", //
                avatarNew: arr.avatar, // 用户头像[重命名][缺]
                qnameNew: arr.qname, // 用户昵称
                usrNew: arr.usr || "--", // 账号名称
                enableNew: arr.enable || "--", // 是否禁用
                activeNew: arr.active || "--", // 活跃度
                roleNew: arr.role || "--", // 用户角色[重命名]
                // role: arr.role || '--', // 用户角色[重命名]
                mobileNew: arr.mobile || "--", // 电话
                emailNew: arr.email || "--", // 邮箱
                groupNew: arr.group || "--", // 分组
                createTimeNew: arr.gts || "--", // 创建时间
                lastLoginTsNew: arr.lastLoginTs || "--", // 最后登录时间
                sourceNew: arr.source || "--", // 用于判断是否储能用户
                uidNew: arr.uid || "--", //
                addCollectorPermissions: arr.addCollectorPermissions==false?false:true,  //是否有新增数采器权限
                rolePermissionId: arr.roleId, //厂家创建经销商账号选择的角色权限ID
                riyueyuanUserTypeRid: arr.rid //日月元新增用户类型标识
              });
              // this.enterAccount(arr);
                    // 通知显示账号信息页(隐藏table)
                    this.$emit("noticeDeviceBox", false);
              
              // 关闭搜索下拉盒
              this.searchAccountBox = false;
            }
          });
        });
      } else {
        this.$emit("noticeDeviceBox", true);
      }
    },
    //================
    // ==============================
    // 树形控件-拖拽
    // ==============================
    handleDragStart (node, ev) {
      // console.log('drag start', node);
      this.treeGroupData.uid = node.data.uid;
    },
    handleDragEnter (draggingNode, dropNode, ev) {
      if (dropNode) {
        // console.log('tree drag enter: ', dropNode.label);
      }
    },
    handleDragLeave (draggingNode, dropNode, ev) {
      if (dropNode) {
        // console.log('tree drag leave: ', dropNode.label);
      }
    },
    handleDragOver (draggingNode, dropNode, ev) {
      if (dropNode) {
        // console.log('tree drag over: ', dropNode.label);
      }
    },
    handleDragEnd (draggingNode, dropNode, dropType, ev) {
      if (dropNode) {
        this.treeGroupData.pid = dropNode.data.uid;
        this.getWebTransferAccountToDist();
        // console.log('tree drag end: ', dropNode && dropNode.label, dropType);
      }
    },
    handleDrop (draggingNode, dropNode, dropType, ev) {
      if (dropNode) {
        // console.log('tree drop: ', dropNode.label, dropType);
      }
    },
    // 能否放置（拖拽节点、放置节点、放置类型）
    allowDrop (draggingNode, dropNode, type) {
      // console.log("[能否放置allowDrop-draggingNode]", draggingNode);
      // console.log("[能否放置allowDrop-dropNode]", dropNode);
      // console.log("[能否放置allowDrop-type]", type);
      // return type === "prev" || type === "next"||type === "inner";
      // 等级对应数字（一级1、二级2、三级3）
      // (1)拖入上一级-允许放置上一级的内部
      if (
        draggingNode.level - dropNode.level == 0 ||
        draggingNode.level - dropNode.level == 1
      ) {
        return type === "prev" || type === "next" || type === "inner";
      }
      // (3)其它拖入禁止放置
      else {
        return false;
      }
    },
    // 能否拖拽（拖拽节点）
    allowDrag (draggingNode) {
      // return draggingNode.data.label.indexOf('禁止') === -1;
      return true;
    },
    // ==============================
    relatedOwner () {
      if(this.disPermissionsLogo&&!this.btnList.includes('link_owner')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.$refs.relationFormRef.resetFields();
      this.relationForm.usr = "";
      this.showRelatedOwnerDialog = true;
    },
    relatedOwner1 () {
      this.$refs.relationFormRef.validate(valid => {
      if (!valid) return false;
      let params = {
        usr: this.relationForm.usr
      };
        this.$request.get("distAddPlantOwner", params).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("account.relatedSuccess"));
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
          this.showRelatedOwnerDialog = false;
        });
     });
    },
    closeSearchBox () {
      // console.log("close-searchbox");
      this.searchAccountBox = false;
    },
    // 实时模糊查询账户
    getSearchAccount () {
      this.searchAccountBox = true;
      // console.log("searching");

      // 展示在下拉盒 分页接口 取最大pagesize=100
      let param = {
        // ...this.search,
        // 实时搜索账户
        usr: this.search.usr,
        page: 0,
        pagesize: 100,
        devtype: 2304
      };
      this.loadingSearchAccountBox = true;
      this.$request.get("webQueryUsrEs", param).then(res => {
        if (res.err === 0) {
          this.searchAccountList = res.dat.account;
        } else {
          this.searchAccountList = [];
        }
        this.loadingSearchAccountBox = false;
      });
    },
    // 点击获取分组列表
    getClickGroupList (groupIdClick) {
      // this.loadingGroupAccount = true;
      // this.currentGroupId = groupIdClick;
      // console.log("notice-group", groupIdClick);
      // 通知请求该组账户列表并显示
      // this.$emit('noticeGroupId', gropuId);
      // 通知显示table(隐藏账号信息页)
      this.$emit("noticeDeviceBox", true);
      // 存store
      this.$store.commit("saveGroupIdClick", {
        groupIdClick: groupIdClick.id,
        groupNameClick: groupIdClick.groupName
      });
    },
    // 查询用户列表
    // getAccountList (reset) {
    //   if (reset) this.pagination.currentPage = 1;
    //   let param = {
    //     ...this.search,
    //     page: this.pagination.currentPage - 1,
    //     pagesize: this.pagination.pagesize
    //   };
    //   this.$request.get("webQueryUsrEs", param).then(res => {
    //     if (res.err === 0) {
    //       res.dat.account.forEach(item => {
    //         item.role = this.$filter.role(item.role).name;
    //         item.active = this.searchOptions.activeStatus[item.active];
    //         item.enable = this.searchOptions.accountStatus[item.enable];
    //       });
    //       this.accountList = res.dat.account;
    //       this.pagination.total = res.dat.total;
    //     } else {
    //       // this.$message.warning(this.$t(`errCode.${res.err}`));
    //       this.accountList = [];
    //       this.pagination.total = 0;
    //     }
    //   });
    // },
    // 搜索分组(本地过滤)
    // getOneGroup() {
    //   // console.log("this.search.groupname", this.search.groupname);
    //   // console.log(this.search.groupname == '');
    //   // this.search.groupname为''
    //   if (this.search.groupname == "") {
    //     // console.log("null");
    //     this.groupListClick = this.groupListClick;
    //     return;
    //   }
    //   this.groupListClick = this.groupListClick.filter(
    //     item => item.name == this.search.groupname
    //   );
    // },
    // 获取分组数据 =====
    getGroupData () {
      this.$request.getDEVMicroservices("/ppr/web/iotSysUserGroup/auth/getList").then(res => {
        if (res.code == 0) {
          this.groupList=res.data
        }
      });
    },
    getData () {
      // this.loadingGroupAccount = true;
      let param = {
        // id: "5c8776f1954d2b312245ba08"
      };
      this.$request.getDEVMicroservices("/ppr/web/iotSysUserGroup/auth/getList", param).then(res => {
        if (res.code == 0 && res.data && res.data.length) {
          this.groupListClick = res.data;
          this.groupIdClick1 = this.groupListClick[0].id;
          this.groupNameClick1 = this.groupListClick[0].groupName;
          this.$store.commit("saveGroupIdClick", {
            groupIdClick: this.groupListClick[0].id,
            groupNameClick: this.groupListClick[0].groupName
          });
        } else {
          this.groupListClick = [];
          this.groupIdClick1 = "";
          this.groupNameClick1 = "";
          this.$store.commit("saveGroupIdClick", {
            groupIdClick: "",
            groupNameClick: ""
          });
          this.$store.state.event.sidebartabUsrGroup = false;
        }
      }).catch(() => {
        this.groupListClick = [];
        this.groupIdClick1 = "";
        this.groupNameClick1 = "";
        this.$store.commit("saveGroupIdClick", {
          groupIdClick: "",
          groupNameClick: ""
        });
        this.$store.state.event.sidebartabUsrGroup = false;
      });
    },
    Bytecheck () {
      this.Byte = false;
      this.usrtip = this.$t("message.uname_is_required");
    },
    pwdcheck () {
      this.strength = false;
      this.pwdtip = this.$t("message.pwd_is_required");
    },
    emailcheck () { },
    phonecheck () { },
    UserByte () {
      var usernameRegex = /^\S{1,31}[a-zA-Z0-9_一-龥]$/;
      if (usernameRegex.test(this.form.name)) {
        //用户格式正确的情况下
        this.Byte = true;
        this.Bytes = this.form.name.length;
      } else {
        this.Byte = false;
        // this.usrtip = this.$t('signup.usrformat')
      }
    },
    Passwordlevel () {
      var reg = /^[\w]{6,32}$/i; //判断密码格式是否正确
      var reg1 = /[a-zA-Z]/; //字母
      var reg2 = /\d/; //数字
      var reg3 = /_/; //下划线
      if (reg.test(this.form.pwd)) {
        //密码格式正确的情况下
        if (
          reg1.test(this.form.pwd) &&
          reg2.test(this.form.pwd) &&
          reg3.test(this.form.pwd)
        ) {
          //高级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#3CBD35";
          this.count = this.$t("signup.qiang");
        } else if (
          (reg1.test(this.form.pwd) && reg2.test(this.form.pwd)) ||
          (reg1.test(this.form.pwd) && reg3.test(this.form.pwd)) ||
          (reg2.test(this.form.pwd) && reg3.test(this.form.pwd))
        ) {
          //中级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FA9D1F";
          this.count = this.$t("signup.zhong");
        } else if (
          reg1.test(this.form.pwd) ||
          reg2.test(this.form.pwd) ||
          reg3.test(this.form.pwd)
        ) {
          //低级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FF0000";
          this.count = this.$t("signup.di");
        }
      } else {
        this.strength = false;
      }
    },
    NewPasswordlevel () {
      var reg = /^[\w]{6,32}$/i; //判断密码格式是否正确
      var reg1 = /[a-zA-Z]/; //字母
      var reg2 = /\d/; //数字
      var reg3 = /_/; //下划线
      if (reg.test(this.resetform.newpwd)) {
        //密码格式正确的情况下
        if (
          reg1.test(this.resetform.newpwd) &&
          reg2.test(this.resetform.newpwd) &&
          reg3.test(this.resetform.newpwd)
        ) {
          //高级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#3CBD35";
          this.count = this.$t("signup.qiang");
        } else if (
          (reg1.test(this.resetform.newpwd) &&
            reg2.test(this.resetform.newpwd)) ||
          (reg1.test(this.resetform.newpwd) &&
            reg3.test(this.resetform.newpwd)) ||
          (reg2.test(this.resetform.newpwd) && reg3.test(this.resetform.newpwd))
        ) {
          //中级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#FA9D1F";
          this.count = this.$t("signup.zhong");
        } else if (
          reg1.test(this.resetform.newpwd) ||
          reg2.test(this.resetform.newpwd) ||
          reg3.test(this.resetform.newpwd)
        ) {
          //低级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#FF0000";
          this.count = this.$t("signup.di");
        }
      } else {
        this.strength = false;
      }
    },
    //打开创建账号按钮 =====
    creatcount () {
      if(this.disPermissionsLogo&&!this.btnList.includes('create_account')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.$refs.creatForm.resetFields();
      this.getGroupData()
      this.showCreatnewcountDialog = true;
      this.form = {
        mobile: "",
        qname: "",
        name: "",
        email: "",
        role: "0", // 默认角色(普通用户)
        id: this.form.id, // 默认分组(首个)
        pwd: "",
        confPwd: "",
        roleId:"",
      };
      this.dataoggerSwithControl = true;//默认可以添加数采器权限
      this.confpwdError = false;
      this.isError = false;
      this.emailError = false;
      this.passpwdError = false;
      this.phoneError = false;
      this.Byte = false;
      this.strength = false;
      this.usrtip = null;
      this.pwdtip = null;
      this.emailtip = null;
      this.phonetip = null;
      this.confpwdtip = null;
    },
    // 创建账号 =====
    creatnewcount () {
      this.$refs.creatForm.validate(valid => {
        if (!valid) return false;
        let addCollectorPermissionsVal,action,param;
        if(this.$store.state.user.role == 2&&this.form.role==2){
          addCollectorPermissionsVal = this.$store.state.user.addCollectorPermissions?true:false
        }else{
          addCollectorPermissionsVal = this.form.role==2?this.dataoggerSwithControl:""
        }
        if(this.form.role == 100||this.form.role == 200){
          action = "addRYYAdmin"
          param = {
            usr: this.form.name,
            email: this.form.email,
            mobile: this.form.mobile,
            qname: this.form.qname,
            source: 1,
            vcode: this.vcode,
            addCollectorPermissions:addCollectorPermissionsVal,
            pwd: encryption.byte2hex(
              encryption.rc4(
                encryption.sha1(this.form.pwd),
                this.$store.state.user.secret
              )
            ),
            // 增加分组 id
            id: this.form.id, // 分组(默认或所选)
            roleId: this.form.roleId,
            rid: this.form.role == 100?1:2
          }
        }else{
          action = this.form.role == 2 ? "addDist" : "addPlantOwner"
          param = {
            usr: this.form.name,
            email: this.form.email,
            mobile: this.form.mobile,
            qname: this.form.qname,
            source: 1,
            vcode: this.vcode,
            addCollectorPermissions:addCollectorPermissionsVal,
            pwd: encryption.byte2hex(
              encryption.rc4(
                encryption.sha1(this.form.pwd),
                this.$store.state.user.secret
              )
            ),
            // 增加分组
            id: this.form.id, // 分组(默认或所选)
            roleId:this.form.role==2?this.form.roleId:"" //厂家为经销商分配角色权限
          }
        }
        this.$request
          .get(action, param)
          .then(res => {
            if (res.err == 0) {
              // this.$message.success(this.$t("account.createSuc"));
              this.showCreatnewcountDialog = false;
              this.creatAccountSucVisible = true;
              // this.getAccountList();
              // 通知侧栏更新账户列表
              this.$store.state.event.updateUsrSList = true;
            }else if(res.err==13){
              this.deviceTipMsg = this.$t('account.limit_UserTypeNum');
              this.creatAccountFailVisible = true;
            }else if(res.err==8){
              this.deviceTipMsg = this.$t('account.limit_UserTypeDataPermission');
              this.creatAccountFailVisible = true;
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = this.$t(`errCode.${res.err}`);
              this.creatAccountFailVisible = true;
            }
            this.getQuerySubAccountTree()
          });
      });
    },
    //获取经销商编码（创建经销商账号时有用）
    getVcode () {
      this.$request.get("queryAccountInfo").then(res => {
        if (res.err == 0) {
          this.AccountUid = res.dat.uid;
          this.treeData3.uid = res.dat.uid;
          this.getQuerySubAccountTree();
          if (res.dat.vendor) {
            this.vcode = res.dat.vendor.vcode.join(",");
          } else if (res.dat.dist) {
            this.vcode = res.dat.dist.vcode.join(",");
          }
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    getDistRoleList () {
      this.$request.get("queryDistRoleList").then(res => {
        if (res.err == 0) {
          this.DistRoleList = res.dat
        }else{
          this.DistRoleList = []
        }
      });
    },
    // 点击进入用户
    enterAccount (info) {
      console.log(info,"infoinfo")
      info.role = this.$filter.role(info.role).name;
      this.$store.commit("saveAccountInfo", {
        avatarNew: info.avatar, // 用户头像[重命名][缺]
        qnameNew: info.qname, // 用户昵称
        usrNew: info.usr || "--", // 账号名称
        enableNew: info.enable || "--", // 是否禁用
        activeNew: info.active || "--", // 活跃度
        roleNew: info.role || "--", // 用户角色[重命名]
        // role: info.role || '--', // 用户角色[重命名]
        mobileNew: info.mobile || "--", // 电话
        emailNew: info.email || "--", // 邮箱
        groupNew: info.group || "--", // 分组
        createTimeNew: info.gts || "--", // 创建时间
        lastLoginTsNew: info.lastLoginTs || "--", // 最后登录时间
        sourceNew: info.source || "--", // 用于判断是否储能用户
        uidNew: info.uid || "--", //
        addCollectorPermissions: info.addCollectorPermissions==false?false:true,  //是否有新增数采器权限
        rolePermissionId: info.roleId, //厂家创建经销商账号选择的角色权限ID
        riyueyuanUserTypeRid: info.rid //日月元新增用户类型标识
      });
      // 通知显示账号信息页(隐藏table)
      this.$emit("noticeDeviceBox", false);

      // 关闭搜索下拉盒
      this.searchAccountBox = false;
    },
    // 创建分组弹窗
    creatgroup () {
      if(this.disPermissionsLogo&&!this.btnList.includes('add_group')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.$refs.form.clearValidate();
      this.group.groupName = null;
      this.group.desc = null;
      this.showCreatgroupDialog = true;
    },
    // 创建分组提交
    creatnewgroup () {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        this.$request
          .postDEVMicroservices("/ppr/web/iotSysUserGroup/auth/save", {
            groupName: this.group.groupName,
            remarks: this.group.desc
          })
          .then(res => {
            if (res.code == 0) {
              // this.$message.success(this.$t("group.creatsuc"));
              this.showCreatgroupDialog = false;
              this.creatGroupSucVisible = true;
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = this.$t(`errCode.${res.err}`);
              this.creatGroupFailVisible = true;
            }
            setTimeout(() => {
              this.getData();
            }, 500);
          });
      });
    },
    // 侧栏分组操作 =====
    // 编辑分组弹窗
    editGroup (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('edit_group')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.$refs.editGroupsForm.clearValidate();
      this.showEditDialog = true;
      this.groupsDatas.groupName = info.groupName;
      this.groupsDatas.desc = info.remarks;
      this.groupsDatas.id = info.id;
    },
    // 编辑分组提交
    submitEditGroup () {
      this.$refs.editGroupsForm.validate(valid => {
        if (!valid) return false;
        this.$request
          .postDEVMicroservices("/ppr/web/iotSysUserGroup/auth/update", {
            id: this.groupsDatas.id,
            remarks: this.groupsDatas.desc,
            groupName: this.groupsDatas.groupName
          })
          .then(res => {
            if (res.code == 0) {
              // this.$message.success(this.$t("group.editsuc"));
              this.showEditDialog = false;
              this.editGroupSucVisible = true;
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = res.message;
              this.editGroupFailVisible = true;
            }
            setTimeout(() => {
              this.getData();
            }, 500);
          });
      });
    },
    // 删除分组弹窗
    delGroup (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('delete_group')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.showDeleteDialog = true;
      this.params = info;
    },
    // 删除分组提交
    submitDelGroup () {
      this.$request.getDEVMicroservices(`/ppr/web/iotSysUserGroup/auth/delete/${this.params.id}`).then(res => {
        if (res.code == 0) {
          // this.$message.success(this.$t("group.deletesuc"));
          this.showDeleteDialog = false;
          this.delGroupSucVisible = true;
          this.getData();
        } else {
          // this.$message.error(this.$t(`errCode.${res.err}`));
          this.deviceTipMsg = res.message;
          this.delGroupFailVisible = true;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.adminAccountSidebarNew {
  width: 264px;

  .help-label {
        font-size: 12px;
        color: rgba(235, 235, 235, 0.8);
        margin-left: 20px;
        display: inline-block;
      }
        //开关按钮
        .eb-switch {

&.el-switch {

  // 轨道
  /deep/.el-switch__core {
    position: relative;
    vertical-align: middle;
    margin: 0;
    display: inline-block;
    width: 40px;
    height: 20px;
    outline: 0;
    border-radius: 10px;
    box-sizing: border-box;
    background-color: #222D35;
    border: 1px solid #707973;
    cursor: pointer;
    transition: border-color .3s, background-color .3s;

    // transition: unset;
    // 开关把手
    &:after {
      content: "";
      width: 12px;
      height: 12px;
      top: 3px;
      left: 3px;
      box-sizing: border-box;
      background-color: #222D35;
      border: 1px solid #ADB9C0;
      border-radius: 100%;
    }
  }
}

// 激活(true)
&.el-switch.is-checked {

  // 轨道
  /deep/.el-switch__core {
    background-color: @primaryTextColor;
    border: 1px solid @primaryTextColor;

    // 开关把手
    &:after {
      content: "";
      left: 100%;
      margin-left: -16px;
      background-color: rgba(255, 255, 255, 1);
      border: 1px solid rgba(255, 255, 255, 1);
    }
  }
}
}

  .grid {
    grid-row-gap: 20px;
  }

  // 创建新账号
  .chuangjian,
  .chongzhi {
    .juxing {
      display: inline-block;
      width: 100px;
      height: 10px;
      border: 0px solid #fff;
      margin-left: 5px;
    }

    .inputlo {
      margin-bottom: -16px;
      height: 20px;
    }

    .input_spans,
    .pwd_span,
    .email_span,
    .phone_span,
    .confpwd_span {
      height: 20px;
      line-height: 20px;
      color: #f56c6c;
      font-size: 12px;
    }

    .input_span {
      height: 20px;
      line-height: 20px;
    }

    .sucess {
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: #999;
      // font-family: "Microsoft YaHei";
    }

    /deep/ .el-form-item__error {
      display: none;
    }
  }

  // 新建弹窗标题
  /deep/.el-form-item__label {
    color: rgba(255, 255, 255, 1);
  }

  // 搜索
  /deep/.el-icon-search:before {
    content: "";
    display: inline-block;
    width: 24px;
    height: 40px;
    background: url("../../../assets/img/admin/Icon_Accounts_Search.png");
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  // 侧栏列表
  .sidebar-list {
    box-shadow: 4px 0px 20px rgba(0, 0, 0, 0.2);
    height: 100%;
    padding: 0 20px;
    background-color: rgb(34, 45, 53);
    color: #ffffff;
    font-size: 16px;
    padding-top: 20px;
    position: relative;
    // 解决侧栏列表滚动问题
    display: flex;
    flex-direction: column;

    /deep/ .el-button.relatedOwnerButton {
      margin-left: 0;
      background-color: #23323d;
      color: #adb9c0;
    }

    /deep/ .el-tree-node:focus>.el-tree-node__content {
      background-color: @primaryColorTransparency30 !important;
    }

    /deep/.el-tree-node__content:hover {
      background-color: @primaryColorTransparency30 !important;
    }

    .icon-a-mingchengyonghushuxingsanren1 {
      color: @primaryTextColor;
    }

    .icon-a-mingchengyonghushuxingdiannao1 {
      color: #5195da !important;
    }

    .icon-a-mingchengyonghushuxingtianjia1 {
      color: #da54fa !important;
    }

    .icon-a-mingchengxiaojiantoushouqi3 {
      color: #70818c;
    }

    //重置滚动条设置
    .treeBox {
      overflow-x: scroll;
      -webkit-overflow-scrolling: touch;
    }

    .treeBox::-webkit-scrollbar-track-piece {
      background-color: rgba(85, 101, 112, 0.2);
      border-left: 1px solid rgba(0, 0, 0, 0);
    }

    .treeBox::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
    }

    .treeBox::-webkit-scrollbar-thumb {
      background-color: #556570;
      background-clip: padding-box;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
      min-height: 28px;
    }

    .treeBox::-webkit-scrollbar-thumb:hover {
      background-color: #556570;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
    }

    .eb-treenew {
      overflow: scroll;
      color: #d9e2e6;
      height: 570px;
      font-size: 12px;
      background-color: #222d35;
      box-sizing: border-box;
    }

    .sidebartableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        height: 100vh;
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner {
        top: 10vh;
        margin-top: 0px;
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    // 添加按钮
    /deep/.el-button {
      display: block;
      width: 100%;
      height: 38px;
      line-height: 38px;
      border: none;
      border-radius: 6px;
      background: @primaryTextColor;
      color: rgb(34, 45, 53);
      font-size: 16px;
      margin-bottom: 20px;
      padding: 0;
    }

    /deep/.el-button .el-icon-add:before {
      content: "";
      display: inline-block;
      height: 16px;
      width: 16px;
      background: url(../../../assets/img/general/Icon_Device_Add.png) no-repeat;
      background-size: 100%;
      background-position: center;
    }

    /deep/.el-icon-add {
      vertical-align: middle;
    }

    // 分割线
    .spliteline {
      width: 100%;
      // height: 1px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      // background: rgba(255, 255, 255, 0.2);
      margin-bottom: 20px;
    }

    .addFenzu {
      display: flex;
      align-items: center;
      justify-content: space-between;

      margin-bottom: 10px;

      .icon-a-mingchengfangxingjia {
        cursor: pointer;
        font-size: 20px;
      }
    }

    //切换盒子
    .tabBox {
      width: 100%;
      border: 1px solid @primaryTextColor;
      margin-bottom: 20px;
      border-radius: 8px;

      .active {
        background-color: @primaryTextColor;
        color: #222d35;
        border-radius: 6px;
      }

      li {
        cursor: pointer;
        display: inline-block;
        width: 50%;
        color: #70818c;
        // background-color: @primaryTextColor;
        text-align: center;
        line-height: 30px;
        font-size: 15px;
        height: 30px;
      }
    }

    // 搜索框
    /deep/.search-input.el-input {
      display: block;
      font-size: 16px;
    }

    /deep/.search-input.el-input .el-input__inner {
      margin-bottom: 20px;
      height: 42px;
      padding-left: 50px;
      color: #ffffff;
    }

    /deep/.search-input .el-input__inner {
      background-color: transparent;
      border-radius: 0;
      border: 1px solid @primaryTextColor;
    }

    /deep/.search-input .el-input__inner:hover {
      border: 1px solid @primaryTextColor;
    }

    /deep/.search-input .el-input__inner:focus {
      border: 1px solid @primaryTextColor;
    }

    // .el-input__suffix
    /deep/.search-input .el-input__prefix {
      left: 14px;
      height: auto;
    }

    /deep/.search-input .el-input__icon {
      color: #ffffff;
      font-size: 20px;
    }

    /deep/.search-input input::-webkit-input-placeholder {
      font-weight: 100;
      color: #ffffff;
      font-size: 14px;
    }

    /deep/.search-input input::-moz-input-placeholder {
      font-weight: 100;
      color: #ffffff;
      font-size: 14px;
    }

    /deep/.search-input input::-ms-input-placeholder {
      font-weight: 100;
      color: #ffffff;
      font-size: 14px;
    }

    // .searchbox {}
    // 项目列表
    /deep/.el-table .cell {
      // padding: 0 40px 0 0;
      padding: 0px;
      text-align: left;
    }

    /deep/.el-table__expand-icon>.el-icon {
      margin-top: -12px;
      position: absolute;
      left: 2px;
    }

    /deep/.el-table .cell,
    /deep/.el-table th div {
      overflow: inherit;
    }

    /deep/.el-table__body .el-table__row .el-table_1_column_2 .cell.el-tooltip {
      font-size: 16px;
      text-align: right;
    }

    /deep/.el-table__body .el-table__row .el-table_2_column_4 .cell.el-tooltip {
      font-size: 16px;
      text-align: right;
    }

    /deep/.el-table__body .el-table__row.expanded .el-table__expand-icon>.el-icon {
      color: @primaryTextColor;
    }

    /deep/.el-table,
    .el-table__expanded-cell {
      background: transparent;
      border: none;
      color: #ffffff;
    }

    /deep/.el-table--border::after,
    .el-table--group::after {
      width: 0;
    }

    /deep/.el-table__expanded-cell[class*="cell"] {
      padding: 0;
    }

    /deep/.el-table--scrollable-x .el-table__body-wrapper:last-child {
      overflow-x: hidden;
    }

    /deep/.el-table .cell.el-tooltip {
      text-align: left;
      padding: 0;
    }

    /deep/.el-table th,
    .el-table tr {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table__body tr,
    .el-table__body td {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table--enable-row-transition .el-table__body td {
      border: none;
      background-color: rgb(34, 45, 53);
    }

    /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table,
    .el-table__expanded-cell {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table__row.hover_row {
      border: none;
    }

    /deep/.el-table__body-wrapper .el-table__expand-icon>.el-icon {
      color: #ffffff;
    }

    .inputCell {
      position: relative;
      z-index: 9999;
      margin-top: -22px;
      // width: 206px;
      width: 100%;

      // 实时搜索下拉盒
      .searchAccountBox {
        position: absolute;
        width: 100%;
        top: 0px;
        // border:1px solid red;
        border: 1px solid @primaryTextColor;
        border-top: 1px solid rgba(255, 255, 255, 0.2);
        padding: 8px 0px;
        // border-radius: 8px;
        background: rgba(34, 45, 53, 1);
        color: rgba(255, 255, 255, 1);
        box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
        max-height: 336px;
        overflow: auto;

        .searchAccountCell {
          width: 100%;
          display: inline-block;
          padding: 8px 16px;
          cursor: pointer;
          font-size: 14px;
        }

        // 加载态
        /deep/.el-loading-mask {
          background-color: rgb(34, 45, 53, 0.5);
        }

        /deep/.el-loading-spinner i {
          color: @primaryTextColor;
        }

        /deep/.el-loading-spinner .path {
          stroke: @primaryTextColor;
        }
      }
    }
  }

  .el-dropdown-pro {
    width: 100%;
    max-width: 206px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .showlabel {
      width: 100%;
      max-width: 247px;
      color: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0px;

      .countbox {
        width: 90%;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .pnamebox {
          // display: block;
          // text-align: left;
          width: 50%;
          // padding-top: 5px;
          margin-right: 5px;

          .pname {
            display: inline-block;
            padding-top: 5px;
            width: 100%;
            font-family: Microsoft YaHei;
            font-size: 16px;
            font-weight: bold;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }
  }

  // 侧栏账号列表
  .proDeviceList {

    // 头像
    .device-item-avatar {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      margin-right: 20px;
    }

    /deep/.el-table__empty-block {
      height: auto;
    }

    /deep/.el-table__expand-icon {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    /deep/.el-table__expand-icon .el-icon-arrow-right:before {
      content: "";
      display: inline-block;
      height: 24px;
      width: 24px;
      background: url(../../../assets/img/admin/Icon_Group_Open.png);
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
    }

    /deep/.el-table__expand-icon--expanded .el-icon-arrow-right:before {
      content: "";
      display: inline-block;
      height: 24px;
      width: 24px;
      background: url(../../../assets/img/admin/Icon_Group_Close.png);
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
    }

    .group-box {
      position: absolute;
      // left:-20px;
      margin-top: -12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .group-label {
        display: flex;
        justify-content: flex-start;
        width: 78%;

        // margin-left: -20px;
        .label-name {
          display: inline-block;
          width: 60%;
          // 处理分组名称过长
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          cursor: pointer;
        }

        .label-num {
          display: inline-block;
          margin-left: 5px;
          // 计数值超大时
          // line-height: 1;
        }

        // 激活
        &.activeGroup {
          color: @primaryTextColor;
        }
      }

      .group-operate {
        display: none;

        // 侧栏分组编辑与删除
        .operate-box {
          display: flex;
          align-items: center;

          .ico-edit {
            background: url(../../../assets/img/general/Icon_Pencil_Dark.png);
          }

          .ico-del {
            background: url(../../../assets/img/general/Icon_Del_Dark.png);
          }

          .ico {
            display: inline-block;
            width: 16px;
            height: 16px;
            background-repeat: no-repeat;
            background-size: 16px 16px;
            background-position: center;
            cursor: pointer;
          }
        }
      }

      &:hover {
        .group-operate {
          display: block;
        }
      }
    }
  }
}

// 滚动条
/deep/::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background-color: transparent;
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>
<style lang="less">
// 筛选下拉菜单
.select-search-pro {
  width: 200px;
  background: #222d35;
  font-family: Microsoft YaHei;
  border-radius: 6px;
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border: none;

  .el-select-dropdown__wrap {
    max-height: 546px;
  }

  .el-select-group__wrap:not(:last-of-type)::after {
    height: 0px;
  }

  .el-select-group__title {
    padding-left: 16px;
    font-size: 14px;
    color: #ffffff;
    border-bottom: 1px solid #424e56;
    line-height: 39px;
    margin-top: 10px;
  }

  .el-select-dropdown__item {
    padding-left: 16px;
    font-size: 14px;
    text-align: left;
    background: #222d35;
    color: #ffffff;
    font-family: Microsoft YaHei;
  }

  .el-select-group__wrap {
    padding-bottom: 0px;
  }

  // .el-select-dropdown__item.hover {
  // }
  .el-select-dropdown__item:hover {
    background: #222d35;
    color: #ffffff;
  }

  .el-select-dropdown__item.selected:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    margin-right: 5px;
    position: absolute;
    top: 6px;
    right: 12px;
  }
}

// 切换项目的悬浮框
.el-dropdownmenu-pro {
  // overflow: hidden;
  background: #202d35;
  color: #ffffff;
  border-radius: 6px;
  border: none;
  padding: 10px 0px;

  // min-width: 100px;
  // min-height: 30px;
  .el-dropdown-menu__item {
    background: #202d35;
    color: #ffffff;
    border: none;
    font-size: 16px;
  }

  .el-dropdown-menu__item.selected,
  .el-dropdown-menu__item:hover,
  .el-dropdown-menu__item:focus {
    background: #202d35;
    color: @primaryTextColor;
    border: none;
  }

  .el-dropdown-menu__item:hover {
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-dropdown-menu__item:not(:last-child) {
    border: none;
  }

  .popper__arrow {
    display: none;
  }

  &.el-popper[x-placement^="right"] {
    margin-left: 5px;
  }
}

.selectClearNew {

  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}
</style>
<style>
</style>
<style lang="less">
/**
  * 树形控件(自定义版)
  */
// ##################################
// @background:#FBFDF8;
@background: #222d35;
@surface: #222d35;
@onsurface: #d9e2e6;
@outline: #707973;
@onsurfacevariant: #70818c;
@teal: #00a38d;
@primary: #008860;
@blue: #5195da;
@purple: #da54fa;
@secondarycontainer: #222d35;

.mytree {

  // ■■■■■■■■■■ 1111111111 ■■■■■■■■■■
  // [一级盒子]
  &.el-tree {
    cursor: default;
    position: relative;
    background: @background;
    color: @onsurface;

    // ================================
    // 操作盒子
    .operateBox {
      display: flex;
      position: absolute;
      top: 0px;
      right: 16px;

      i {
        color: @outline !important;
        // font-size: 12px;
        font-size: 20px;
      }
    }

    // ================================
    // ●●●●●●●●●● 1111111111 ●●●●●●●●●●
    // [一级节点]
    // (is-expanded is-focusable is-current)
    .el-tree-node {
      white-space: nowrap;
      outline: 0;

      // ********************************
      &:focus>.el-tree-node__content {
        background-color: @background;
      }

      // ********************************
      // 一级标签
      .el-tree-node__content {
        // .................
        // 默认透明、悬浮上色、保证元素不会因尺寸改变而抖动
        border: 1px solid transparent;
        // .................
        cursor: pointer;
        display: flex;
        align-items: center;
        height: 32px;
        line-height: 32px;
        padding-left: 0px !important;

        // ********************************
        // 去掉原组件树状一级的收展图标（自定义图标及事件）
        .el-tree-node__expand-icon.el-icon-caret-right {
          display: none;
          // margin-left: 12px;
          // transform: rotate(0deg);
          // &:before {
          //   // content: "\e9d6";
          //   // font-family: "iconfont";
          //   content: "";
          // }
          // // 展开态
          // &.expanded {
          //   transform: rotate(0deg);
          // }
        }

        // 自定义树状一级收展
        .treeLevelOneHandle {
          display: inline-block;
          width: 20px;
          text-align: center;
          margin-right: 10px;
          margin-left: 20px;
          color: @onsurfacevariant;
          font-size: 14px;
        }

        // ********************************
        // 一级-图标
        // (expanded)
        &>.el-tree-node__expand-icon {
          padding: 6px;
        }

        .el-tree-node__expand-icon {
          cursor: pointer;
          color: @onsurfacevariant;
          font-size: 12px;
          transition: transform 0.3s ease-in-out,
            -webkit-transform 0.3s ease-in-out;
        }

        // // 展开状态时
        // .el-tree-node__expand-icon.expanded {
        //   border-left: 1px dashed @outline;
        // }
        // ********************************
        // 一级-文字
        // .el-tree-node__label {}

        // 如果页面自定义标签则[一级-文字]被覆盖
        span {
          i {
            color: @teal;
            margin-right: 4px;
          }

          span {
            font-size: 12px;
          }
        }

        // ********************************
        // 一级标签悬浮
        &:hover {
          background-color: @background;
          border: 1px solid @primary;
          padding-left: 0px !important;
        }

        // ********************************
      }

      // ********************************
      // ■■■■■■■■■■ 2222222222 ■■■■■■■■■■
      // [二级盒子]
      .el-tree-node__children {
        // border-left: 1px dashed @outline;
        // margin-left: 12px;
        border-left: 1px dashed @outline;
        margin-left: 33px;

        // .................
        // 二级节点
        // (is-expanded is-focusable is-current)
        .el-tree-node {

          // ..................
          // height: 32px;
          // line-height: 32px;
          // ..................
          // 二级标签
          .el-tree-node__content {
            // .................
            // 默认透明、悬浮上色、保证元素不会因尺寸改变而抖动
            border: 1px solid transparent;
            // .................
            padding-left: 0px !important;
            // margin-left: 10px!important;
            // border-left: 1px dashed @outline!important;
            height: 32px;
            line-height: 32px;
            position: relative;

            // ................................
            // 层级辅助线
            // &:before {
            //   content: '';
            //   display: inline-block;
            //   width: 1px;
            //   height: 32px;
            //   border-left: 1px dashed @outline;
            //   position: absolute;
            //   top: 0px;
            //   left: 30px;
            // }
            // ................................
            // ********************************
            // 去掉原组件树状一级的收展图标（自定义图标及事件）
            .el-tree-node__expand-icon.el-icon-caret-right {
              display: inline-block;
              margin-left: 4px;
              transform: rotate(0deg);

              &:before {
                content: "\ea27";
                font-family: "iconfont";
              }

              // 展开态
              &.expanded {
                transform: rotate(90deg);
              }
            }

            // 自定义树状一级收展
            .treeLevelOneHandle {
              display: none;
            }

            // ********************************
            // 二级-图标
            // (expanded)
            //.el-tree-node__expand-icon {
            // border: none;
            // border-left: 1px dashed @outline;
            //}

            // 展开状态时
            //.el-tree-node__expand-icon.expanded {
            // border: none;
            // 注意：涉及旋转90度，
            // 应是bottom边线顺时旋转90度后变为left边线。
            // border-bottom: 1px dashed @outline;
            //}

            // ********************************
            // 二级-文字
            //.el-tree-node__label {}

            // 如果页面自定义标签则[一级-文字]被覆盖
            span {
              i {
                color: @blue;
                margin-right: 4px;
              }
            }

            // ********************************
            // 二级标签悬浮
            &:hover {
              background: @background;
              border: 1px solid @primary;
              padding-left: 0px !important;

              &:before {
                left: 29px;
              }

              // ********************************
              // 操作盒子
              .operateBox {
                top: 0px;
                right: 16px;
              }

              // ********************************
            }

            // ********************************
          }

          // ■■■■■■■■■■ 3333333333 ■■■■■■■■■■
          // [三级盒子]
          .el-tree-node__children {
            // border-left: none;
            border-left: 1px dashed @outline;
            margin-left: 21px;

            // .................
            // 三级节点
            // (is-expanded is-focusable is-current)
            .el-tree-node {

              // ..................
              // height: 32px;
              // line-height: 32px;
              // ..................
              // 三级标签
              .el-tree-node__content {
                // .................
                // 默认透明、悬浮上色、保证元素不会因尺寸改变而抖动
                border: 1px solid transparent;
                // .................
                height: 32px;
                line-height: 32px;
                padding-left: 0px !important;
                position: relative;

                // ................................
                // 层级辅助线
                // &:before,
                // &:after {
                //   content: '';
                //   display: inline-block;
                //   width: 1px;
                //   height: 32px;
                //   border-left: 1px dashed @outline;
                //   position: absolute;
                //   top: 0px;
                // }
                // &:before {
                //   left: 30px;
                // }
                // &:after {
                //   left: 50px;
                // }
                // ................................
                // ********************************
                // 去掉原组件树状一级的收展图标（自定义图标及事件）
                .el-tree-node__expand-icon.el-icon-caret-right {
                  display: inline-block;
                  margin-left: 4px;
                  transform: rotate(0deg);

                  &:before {
                    content: "\ea27";
                    font-family: "iconfont";
                  }

                  // 展开态
                  &.expanded {
                    transform: rotate(90deg);
                  }
                }

                // 自定义树状一级收展
                .treeLevelOneHandle {
                  display: none;
                }

                // ********************************
                // 三级-图标
                // (is-leaf)
                //.el-tree-node__expand-icon {}

                // 三级-文字
                //.el-tree-node__label {}

                // 如果页面自定义标签则[一级-文字]被覆盖
                span {
                  i {
                    color: @purple;
                    margin-right: 4px;
                  }
                }

                // ********************************
                // 三级标签悬浮
                &:hover {
                  background: @background;
                  border: 1px solid @primary;
                  padding-left: 0px !important;

                  &:before {
                    left: 29px;
                  }

                  &:after {
                    left: 49px;
                  }

                  // ********************************
                  // 操作盒子
                  .operateBox {
                    top: 0px;
                    right: 16px;
                  }

                  // ********************************
                }

                // ********************************
              }

              // ■■■■■■■■■■ 4444444444 ■■■■■■■■■■
              // [四级盒子]
              .el-tree-node__children {
                // border-left: none;
                border-left: 1px dashed @outline;
                margin-left: 21px;

                // .................
                // 四级节点
                // (is-expanded is-focusable is-current)
                .el-tree-node {

                  // ..................
                  // height: 32px;
                  // line-height: 32px;
                  // ..................
                  // 四级标签
                  .el-tree-node__content {
                    // .................
                    // 默认透明、悬浮上色、保证元素不会因尺寸改变而抖动
                    border: 1px solid transparent;
                    // .................
                    height: 32px;
                    line-height: 32px;
                    padding-left: 0px !important;
                    position: relative;

                    // ................................
                    // 层级辅助线
                    // &:before,
                    // &:after {
                    //   content: '';
                    //   display: inline-block;
                    //   width: 1px;
                    //   height: 32px;
                    //   border-left: 1px dashed @outline;
                    //   position: absolute;
                    //   top: 0px;
                    // }
                    // &:before {
                    //   left: 30px;
                    // }
                    // &:after {
                    //   left: 50px;
                    // }
                    // ................................
                    // ********************************
                    // 去掉原组件树状一级的收展图标（自定义图标及事件）
                    .el-tree-node__expand-icon.el-icon-caret-right {
                      display: inline-block;
                      margin-left: 4px;
                      transform: rotate(0deg);

                      &:before {
                        content: "\ea27";
                        font-family: "iconfont";
                      }

                      // 展开态
                      &.expanded {
                        transform: rotate(90deg);
                      }
                    }

                    // 自定义树状一级收展
                    .treeLevelOneHandle {
                      display: none;
                    }

                    // ********************************
                    // 四级-图标
                    // (is-leaf)
                    //.el-tree-node__expand-icon {}

                    // 四级-文字
                    //.el-tree-node__label {}

                    // 如果页面自定义标签则[一级-文字]被覆盖
                    span {
                      i {
                        color: @purple;
                        margin-right: 4px;
                      }
                    }

                    // ********************************
                    // 四级标签悬浮
                    &:hover {
                      background: @background;
                      border: 1px solid @primary;
                      padding-left: 0px !important;

                      &:before {
                        left: 29px;
                      }

                      &:after {
                        left: 49px;
                      }

                      // ********************************
                      // 操作盒子
                      .operateBox {
                        top: 0px;
                        right: 16px;
                      }

                      // ********************************
                    }

                    // ********************************
                  }

                  // ■■■■■■■■■■ 5555555555 ■■■■■■■■■■
                  // [五级盒子]
                  .el-tree-node__children {
                    // border-left: none;
                    border-left: 1px dashed @outline;
                    margin-left: 21px;

                    // .................
                    // 五级节点
                    // (is-expanded is-focusable is-current)
                    .el-tree-node {

                      // ..................
                      // height: 32px;
                      // line-height: 32px;
                      // ..................
                      // 五级标签
                      .el-tree-node__content {
                        // .................
                        // 默认透明、悬浮上色、保证元素不会因尺寸改变而抖动
                        border: 1px solid transparent;
                        // .................
                        height: 32px;
                        line-height: 32px;
                        padding-left: 0px !important;
                        position: relative;

                        // ................................
                        // 层级辅助线
                        // &:before,
                        // &:after {
                        //   content: '';
                        //   display: inline-block;
                        //   width: 1px;
                        //   height: 32px;
                        //   border-left: 1px dashed @outline;
                        //   position: absolute;
                        //   top: 0px;
                        // }
                        // &:before {
                        //   left: 30px;
                        // }
                        // &:after {
                        //   left: 50px;
                        // }
                        // ................................
                        // ********************************
                        // 去掉原组件树状一级的收展图标（自定义图标及事件）
                        .el-tree-node__expand-icon.el-icon-caret-right {
                          display: inline-block;
                          margin-left: 4px;
                          transform: rotate(0deg);

                          &:before {
                            content: "\ea27";
                            font-family: "iconfont";
                          }

                          // 展开态
                          &.expanded {
                            transform: rotate(90deg);
                          }
                        }

                        // 自定义树状一级收展
                        .treeLevelOneHandle {
                          display: none;
                        }

                        // ********************************
                        // 五级-图标
                        // (is-leaf)
                        //.el-tree-node__expand-icon {}

                        // 五级-文字
                        //.el-tree-node__label {}

                        // 如果页面自定义标签则[一级-文字]被覆盖
                        span {
                          i {
                            color: @purple;
                            margin-right: 4px;
                          }
                        }

                        // ********************************
                        // 五级标签悬浮
                        &:hover {
                          background: @background;
                          border: 1px solid @primary;
                          padding-left: 0px !important;

                          &:before {
                            left: 29px;
                          }

                          &:after {
                            left: 49px;
                          }

                          // ********************************
                          // 操作盒子
                          .operateBox {
                            top: 0px;
                            right: 16px;
                          }

                          // ********************************
                        }

                        // ********************************
                      }

                      // ■■■■■■■■■■ 6666666666 ■■■■■■■■■■
                      // [六级盒子]
                      .el-tree-node__children {
                        // border-left: none;
                        border-left: 1px dashed @outline;
                        margin-left: 21px;

                        // .................
                        // 六级节点
                        // (is-expanded is-focusable is-current)
                        .el-tree-node {

                          // ..................
                          // height: 32px;
                          // line-height: 32px;
                          // ..................
                          // 六级标签
                          .el-tree-node__content {
                            // .................
                            // 默认透明、悬浮上色、保证元素不会因尺寸改变而抖动
                            border: 1px solid transparent;
                            // .................
                            height: 32px;
                            line-height: 32px;
                            padding-left: 0px !important;
                            position: relative;

                            // ................................
                            // 层级辅助线
                            // &:before,
                            // &:after {
                            //   content: '';
                            //   display: inline-block;
                            //   width: 1px;
                            //   height: 32px;
                            //   border-left: 1px dashed @outline;
                            //   position: absolute;
                            //   top: 0px;
                            // }
                            // &:before {
                            //   left: 30px;
                            // }
                            // &:after {
                            //   left: 50px;
                            // }
                            // ................................
                            // ********************************
                            // 去掉原组件树状一级的收展图标（自定义图标及事件）
                            .el-tree-node__expand-icon.el-icon-caret-right {
                              display: inline-block;
                              margin-left: 4px;
                              transform: rotate(0deg);

                              &:before {
                                content: "\ea27";
                                font-family: "iconfont";
                              }

                              // 展开态
                              &.expanded {
                                transform: rotate(90deg);
                              }
                            }

                            // 自定义树状一级收展
                            .treeLevelOneHandle {
                              display: none;
                            }

                            // ********************************
                            // 六级-图标
                            // (is-leaf)
                            //.el-tree-node__expand-icon {}

                            // 六级-文字
                            //.el-tree-node__label {}

                            // 如果页面自定义标签则[一级-文字]被覆盖
                            span {
                              i {
                                color: @purple;
                                margin-right: 4px;
                              }
                            }

                            // ********************************
                            // 六级标签悬浮
                            &:hover {
                              background: @background;
                              border: 1px solid @primary;
                              padding-left: 0px !important;

                              &:before {
                                left: 29px;
                              }

                              &:after {
                                left: 49px;
                              }

                              // ********************************
                              // 操作盒子
                              .operateBox {
                                top: 0px;
                                right: 16px;
                              }

                              // ********************************
                            }

                            // ********************************
                          }

                          // ■■■■■■■■■■ 7777777777 ■■■■■■■■■■
                          // [七级盒子]
                          .el-tree-node__children {
                            // border-left: none;
                            border-left: 1px dashed @outline;
                            margin-left: 21px;

                            // .................
                            // 七级节点
                            // (is-expanded is-focusable is-current)
                            .el-tree-node {

                              // ..................
                              // height: 32px;
                              // line-height: 32px;
                              // ..................
                              // 七级标签
                              .el-tree-node__content {
                                // .................
                                // 默认透明、悬浮上色、保证元素不会因尺寸改变而抖动
                                border: 1px solid transparent;
                                // .................
                                height: 32px;
                                line-height: 32px;
                                padding-left: 0px !important;
                                position: relative;

                                // ................................
                                // 层级辅助线
                                // &:before,
                                // &:after {
                                //   content: '';
                                //   display: inline-block;
                                //   width: 1px;
                                //   height: 32px;
                                //   border-left: 1px dashed @outline;
                                //   position: absolute;
                                //   top: 0px;
                                // }
                                // &:before {
                                //   left: 30px;
                                // }
                                // &:after {
                                //   left: 50px;
                                // }
                                // ................................
                                // ********************************
                                // 去掉原组件树状一级的收展图标（自定义图标及事件）
                                .el-tree-node__expand-icon.el-icon-caret-right {
                                  display: inline-block;
                                  margin-left: 4px;
                                  transform: rotate(0deg);

                                  &:before {
                                    content: "\ea27";
                                    font-family: "iconfont";
                                  }

                                  // 展开态
                                  &.expanded {
                                    transform: rotate(90deg);
                                  }
                                }

                                // 自定义树状一级收展
                                .treeLevelOneHandle {
                                  display: none;
                                }

                                // ********************************
                                // 七级-图标
                                // (is-leaf)
                                //.el-tree-node__expand-icon {}

                                // 七级-文字
                                //.el-tree-node__label {}

                                // 如果页面自定义标签则[一级-文字]被覆盖
                                span {
                                  i {
                                    color: @purple;
                                    margin-right: 4px;
                                  }
                                }

                                // ********************************
                                // 七级标签悬浮
                                &:hover {
                                  // background: @background;
                                  border: 1px solid @primary;
                                  padding-left: 0px !important;

                                  &:before {
                                    left: 29px;
                                  }

                                  &:after {
                                    left: 49px;
                                  }

                                  // ********************************
                                  // 操作盒子
                                  .operateBox {
                                    top: 0px;
                                    right: 16px;
                                  }

                                  // ********************************
                                }

                                // ********************************
                              }

                              // ********************************
                              // // ■■■■■■■■■■ 88888888 ■■■■■■■■■■
                              // // [八级盒子]（暂无）
                              // .el-tree-node__children {}
                              // // ■■■■■■■■■■ 88888888 ■■■■■■■■■■
                              // ********************************
                              // [悬浮态]
                              // 七级节点悬浮
                              // &:hover {}
                              // ********************************
                              // [激活态]
                              // 七级节点激活
                              &.is-current {
                                background: linear-gradient(0deg,
                                    fade(@primary, 8%),
                                    fade(@primary, 8%)),
                                  @surface;

                                // 7级（本级显示）
                                .el-tree-node__content {
                                  background: @secondarycontainer;
                                  padding-left: 0px !important;
                                  // border: none;
                                }

                                // 8级（子级显示）（暂无）
                                // .el-tree-node__children {}
                              }

                              // ........................
                            }
                          }

                          // ■■■■■■■■■■ 7777777777 ■■■■■■■■■■
                          // ********************************
                          // [悬浮态]
                          // 六级节点悬浮
                          // &:hover {}
                          // ********************************
                          // [激活态]
                          // 六级节点激活
                          &.is-current {
                            background: linear-gradient(0deg,
                                fade(@primary, 8%),
                                fade(@primary, 8%)),
                              @surface;

                            // 6级（本级显示）
                            .el-tree-node__content {
                              background: @secondarycontainer;
                              padding-left: 0px !important;
                              // border: none;
                            }

                            // 7级（子级显示）
                            .el-tree-node__children {
                              background: linear-gradient(0deg,
                                  fade(@primary, 8%),
                                  fade(@primary, 8%)),
                                @surface;
                            }
                          }

                          // ........................
                        }
                      }

                      // ■■■■■■■■■■ 6666666666 ■■■■■■■■■■
                      // ********************************
                      // [悬浮态]
                      // 五级节点悬浮
                      // &:hover {}
                      // ********************************
                      // [激活态]
                      // 五级节点激活
                      &.is-current {
                        background: linear-gradient(0deg,
                            fade(@primary, 8%),
                            fade(@primary, 8%)),
                          @surface;

                        // 5级（本级显示）
                        .el-tree-node__content {
                          background: @secondarycontainer;
                          padding-left: 0px !important;
                          // border: none;
                        }

                        // 6级（子级显示）
                        .el-tree-node__children {
                          background: linear-gradient(0deg,
                              fade(@primary, 8%),
                              fade(@primary, 8%)),
                            @surface;

                          .el-tree-node {
                            background: linear-gradient(0deg,
                                fade(@primary, 8%),
                                fade(@primary, 8%)),
                              @surface;

                            .el-tree-node__content {
                              background: linear-gradient(0deg,
                                  fade(@primary, 8%),
                                  fade(@primary, 8%)),
                                @surface;

                              &:hover {
                                border: 1px solid @primary;
                                background: linear-gradient(0deg,
                                    fade(@primary, 8%),
                                    fade(@primary, 8%)),
                                  @surface;
                              }
                            }

                            // 7级（子级显示）
                            .el-tree-node__children {
                              background: linear-gradient(0deg,
                                  fade(@primary, 8%),
                                  fade(@primary, 8%)),
                                @surface;
                            }
                          }
                        }
                      }

                      // ........................
                    }
                  }

                  // ■■■■■■■■■■ 5555555555 ■■■■■■■■■■
                  // ********************************
                  // [悬浮态]
                  // 四级节点悬浮
                  // &:hover {}
                  // ********************************
                  // [激活态]
                  // 四级节点激活
                  &.is-current {
                    background: linear-gradient(0deg,
                        fade(@primary, 8%),
                        fade(@primary, 8%)),
                      @surface;

                    // 4级（本级显示）
                    .el-tree-node__content {
                      background: @secondarycontainer;
                      padding-left: 0px !important;
                      // border: none;
                    }

                    // 5级（子级显示）
                    .el-tree-node__children {
                      background: linear-gradient(0deg,
                          fade(@primary, 8%),
                          fade(@primary, 8%)),
                        @surface;

                      .el-tree-node {
                        background: linear-gradient(0deg,
                            fade(@primary, 8%),
                            fade(@primary, 8%)),
                          @surface;

                        .el-tree-node__content {
                          background: linear-gradient(0deg,
                              fade(@primary, 8%),
                              fade(@primary, 8%)),
                            @surface;

                          &:hover {
                            border: 1px solid @primary;
                            background: linear-gradient(0deg,
                                fade(@primary, 8%),
                                fade(@primary, 8%)),
                              @surface;
                          }
                        }

                        // 6级（子级显示）
                        .el-tree-node__children {
                          background: linear-gradient(0deg,
                              fade(@primary, 8%),
                              fade(@primary, 8%)),
                            @surface;

                          .el-tree-node {
                            background: linear-gradient(0deg,
                                fade(@primary, 8%),
                                fade(@primary, 8%)),
                              @surface;

                            .el-tree-node__content {
                              background: linear-gradient(0deg,
                                  fade(@primary, 8%),
                                  fade(@primary, 8%)),
                                @surface;

                              &:hover {
                                border: 1px solid @primary;
                                background: linear-gradient(0deg,
                                    fade(@primary, 8%),
                                    fade(@primary, 8%)),
                                  @surface;
                              }
                            }

                            // 7级（子级显示）
                            .el-tree-node__children {
                              background: linear-gradient(0deg,
                                  fade(@primary, 8%),
                                  fade(@primary, 8%)),
                                @surface;
                            }
                          }
                        }
                      }
                    }
                  }

                  // ........................
                }
              }

              // ■■■■■■■■■■ 4444444444 ■■■■■■■■■■
              // ********************************
              // [悬浮态]
              // 三级节点悬浮
              // &:hover {}
              // ********************************
              // [激活态]
              // 三级节点激活
              &.is-current {
                background: linear-gradient(0deg,
                    fade(@primary, 8%),
                    fade(@primary, 8%)),
                  @surface;

                // 3级（本级显示）
                .el-tree-node__content {
                  background: @secondarycontainer;
                  padding-left: 0px !important;
                  // border: none;
                }

                // 4级（子级显示）
                .el-tree-node__children {
                  background: linear-gradient(0deg,
                      fade(@primary, 8%),
                      fade(@primary, 8%)),
                    @surface;

                  .el-tree-node {
                    background: linear-gradient(0deg,
                        fade(@primary, 8%),
                        fade(@primary, 8%)),
                      @surface;

                    .el-tree-node__content {
                      background: linear-gradient(0deg,
                          fade(@primary, 8%),
                          fade(@primary, 8%)),
                        @surface;

                      &:hover {
                        border: 1px solid @primary;
                        background: linear-gradient(0deg,
                            fade(@primary, 8%),
                            fade(@primary, 8%)),
                          @surface;
                      }
                    }

                    // 5级（子级显示）
                    .el-tree-node__children {
                      background: linear-gradient(0deg,
                          fade(@primary, 8%),
                          fade(@primary, 8%)),
                        @surface;

                      .el-tree-node {
                        background: linear-gradient(0deg,
                            fade(@primary, 8%),
                            fade(@primary, 8%)),
                          @surface;

                        .el-tree-node__content {
                          background: linear-gradient(0deg,
                              fade(@primary, 8%),
                              fade(@primary, 8%)),
                            @surface;

                          &:hover {
                            border: 1px solid @primary;
                            background: linear-gradient(0deg,
                                fade(@primary, 8%),
                                fade(@primary, 8%)),
                              @surface;
                          }
                        }

                        // 6级（子级显示）
                        .el-tree-node__children {
                          background: linear-gradient(0deg,
                              fade(@primary, 8%),
                              fade(@primary, 8%)),
                            @surface;

                          .el-tree-node {
                            background: linear-gradient(0deg,
                                fade(@primary, 8%),
                                fade(@primary, 8%)),
                              @surface;

                            .el-tree-node__content {
                              background: linear-gradient(0deg,
                                  fade(@primary, 8%),
                                  fade(@primary, 8%)),
                                @surface;

                              &:hover {
                                border: 1px solid @primary;
                                background: linear-gradient(0deg,
                                    fade(@primary, 8%),
                                    fade(@primary, 8%)),
                                  @surface;
                              }
                            }

                            // 7级（子级显示）
                            .el-tree-node__children {
                              background: linear-gradient(0deg,
                                  fade(@primary, 8%),
                                  fade(@primary, 8%)),
                                @surface;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }

              // ........................
            }
          }

          // ■■■■■■■■■■ 3333333333 ■■■■■■■■■■
          // ********************************
          // [悬浮态]
          // 二级节点悬浮
          // &:hover {}
          // ********************************
          // [激活态]
          // 二级节点激活
          &.is-current {
            background: linear-gradient(0deg,
                fade(@primary, 8%),
                fade(@primary, 8%)),
              @surface;

            // 2级（本级显示）
            .el-tree-node__content {
              background: @secondarycontainer;
              padding-left: 0px !important;
              // border: none;
            }

            // 3级（子级显示）
            .el-tree-node__children {
              background: linear-gradient(0deg,
                  fade(@primary, 8%),
                  fade(@primary, 8%)),
                @surface;

              .el-tree-node {
                background: linear-gradient(0deg,
                    fade(@primary, 8%),
                    fade(@primary, 8%)),
                  @surface;

                .el-tree-node__content {
                  background: linear-gradient(0deg,
                      fade(@primary, 8%),
                      fade(@primary, 8%)),
                    @surface;

                  &:hover {
                    border: 1px solid @primary;
                    background: linear-gradient(0deg,
                        fade(@primary, 8%),
                        fade(@primary, 8%)),
                      @surface;
                  }
                }

                // 4级（子级显示）
                .el-tree-node__children {
                  background: linear-gradient(0deg,
                      fade(@primary, 8%),
                      fade(@primary, 8%)),
                    @surface;

                  .el-tree-node {
                    background: linear-gradient(0deg,
                        fade(@primary, 8%),
                        fade(@primary, 8%)),
                      @surface;

                    .el-tree-node__content {
                      background: linear-gradient(0deg,
                          fade(@primary, 8%),
                          fade(@primary, 8%)),
                        @surface;

                      &:hover {
                        border: 1px solid @primary;
                        background: linear-gradient(0deg,
                            fade(@primary, 8%),
                            fade(@primary, 8%)),
                          @surface;
                      }
                    }

                    // 5级（子级显示）
                    .el-tree-node__children {
                      background: linear-gradient(0deg,
                          fade(@primary, 8%),
                          fade(@primary, 8%)),
                        @surface;

                      .el-tree-node {
                        background: linear-gradient(0deg,
                            fade(@primary, 8%),
                            fade(@primary, 8%)),
                          @surface;

                        .el-tree-node__content {
                          background: linear-gradient(0deg,
                              fade(@primary, 8%),
                              fade(@primary, 8%)),
                            @surface;

                          &:hover {
                            border: 1px solid @primary;
                            background: linear-gradient(0deg,
                                fade(@primary, 8%),
                                fade(@primary, 8%)),
                              @surface;
                          }
                        }

                        // 6级（子级显示）
                        .el-tree-node__children {
                          background: linear-gradient(0deg,
                              fade(@primary, 8%),
                              fade(@primary, 8%)),
                            @surface;

                          .el-tree-node {
                            background: linear-gradient(0deg,
                                fade(@primary, 8%),
                                fade(@primary, 8%)),
                              @surface;

                            .el-tree-node__content {
                              background: linear-gradient(0deg,
                                  fade(@primary, 8%),
                                  fade(@primary, 8%)),
                                @surface;

                              &:hover {
                                border: 1px solid @primary;
                                background: linear-gradient(0deg,
                                    fade(@primary, 8%),
                                    fade(@primary, 8%)),
                                  @surface;
                              }
                            }

                            // 7级（子级显示）
                            .el-tree-node__children {
                              background: linear-gradient(0deg,
                                  fade(@primary, 8%),
                                  fade(@primary, 8%)),
                                @surface;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          // ********************************
        }
      }

      // ■■■■■■■■■■ 2222222222 ■■■■■■■■■■
      // ********************************
      // [悬浮态]
      // 一级节点悬浮
      // &:hover {}
      // ********************************
      // [激活态]
      // 一级节点激活
      &.is-current {
        background: linear-gradient(0deg,
            fade(@primary, 8%),
            fade(@primary, 8%)),
          @surface;

        // 1级（本级显示）
        .el-tree-node__content {
          background: @secondarycontainer;
          padding-left: 0px !important;
          // border: none;
        }

        // 2级（子级显示）
        .el-tree-node__children {
          background: linear-gradient(0deg,
              fade(@primary, 8%),
              fade(@primary, 8%)),
            @surface;

          .el-tree-node {
            background: linear-gradient(0deg,
                fade(@primary, 8%),
                fade(@primary, 8%)),
              @surface;

            .el-tree-node__content {
              background: linear-gradient(0deg,
                  fade(@primary, 8%),
                  fade(@primary, 8%)),
                @surface;

              &:hover {
                border: 1px solid @primary;
                background: linear-gradient(0deg,
                    fade(@primary, 8%),
                    fade(@primary, 8%)),
                  @surface;
              }
            }

            // 3级（子级显示）
            .el-tree-node__children {
              background: linear-gradient(0deg,
                  fade(@primary, 8%),
                  fade(@primary, 8%)),
                @surface;

              .el-tree-node {
                background: linear-gradient(0deg,
                    fade(@primary, 8%),
                    fade(@primary, 8%)),
                  @surface;

                .el-tree-node__content {
                  background: linear-gradient(0deg,
                      fade(@primary, 8%),
                      fade(@primary, 8%)),
                    @surface;

                  &:hover {
                    border: 1px solid @primary;
                    background: linear-gradient(0deg,
                        fade(@primary, 8%),
                        fade(@primary, 8%)),
                      @surface;
                  }
                }

                // 4级（子级显示）
                .el-tree-node__children {
                  background: linear-gradient(0deg,
                      fade(@primary, 8%),
                      fade(@primary, 8%)),
                    @surface;

                  .el-tree-node {
                    background: linear-gradient(0deg,
                        fade(@primary, 8%),
                        fade(@primary, 8%)),
                      @surface;

                    .el-tree-node__content {
                      background: linear-gradient(0deg,
                          fade(@primary, 8%),
                          fade(@primary, 8%)),
                        @surface;

                      &:hover {
                        border: 1px solid @primary;
                        background: linear-gradient(0deg,
                            fade(@primary, 8%),
                            fade(@primary, 8%)),
                          @surface;
                      }
                    }

                    // 5级（子级显示）
                    .el-tree-node__children {
                      background: linear-gradient(0deg,
                          fade(@primary, 8%),
                          fade(@primary, 8%)),
                        @surface;

                      .el-tree-node {
                        background: linear-gradient(0deg,
                            fade(@primary, 8%),
                            fade(@primary, 8%)),
                          @surface;

                        .el-tree-node__content {
                          background: linear-gradient(0deg,
                              fade(@primary, 8%),
                              fade(@primary, 8%)),
                            @surface;

                          &:hover {
                            border: 1px solid @primary;
                            background: linear-gradient(0deg,
                                fade(@primary, 8%),
                                fade(@primary, 8%)),
                              @surface;
                          }
                        }

                        // 6级（子级显示）
                        .el-tree-node__children {
                          background: linear-gradient(0deg,
                              fade(@primary, 8%),
                              fade(@primary, 8%)),
                            @surface;

                          .el-tree-node {
                            background: linear-gradient(0deg,
                                fade(@primary, 8%),
                                fade(@primary, 8%)),
                              @surface;

                            .el-tree-node__content {
                              background: linear-gradient(0deg,
                                  fade(@primary, 8%),
                                  fade(@primary, 8%)),
                                @surface;

                              &:hover {
                                border: 1px solid @primary;
                                background: linear-gradient(0deg,
                                    fade(@primary, 8%),
                                    fade(@primary, 8%)),
                                  @surface;
                              }
                            }

                            // 7级（子级显示）
                            .el-tree-node__children {
                              background: linear-gradient(0deg,
                                  fade(@primary, 8%),
                                  fade(@primary, 8%)),
                                @surface;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      // ********************************
    }

    // ●●●●●●●●●● 1111111111 ●●●●●●●●●●
    // ================================
    // 叶子节点不加左侧三角指示
    .el-tree-node__expand-icon.el-icon-caret-right.is-leaf {
      width: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      margin-left: 28px !important;

      &:before {
        content: "" !important;
      }
    }

    // ================================
    // 指示器
    .el-tree__drop-indicator {
      position: absolute;
      left: 0;
      right: 0;
      height: 1px;
      background-color: @primary;
    }

    // ================================
  }

  // ■■■■■■■■■■ 1111111111 ■■■■■■■■■■
}

// ##################################
// 树的悬浮下拉框
.mytree-dropdown-list {
  &.el-dropdown-menu {
    max-height: unset;
    min-width: unset;
  }
}

// ##################################
</style>